// import { Badge, Container, Navbar, Button as ButtonStrap } from "react-bootstrap";
// import axios from "axios";
// import no_image from "../images/No_Image_Available.jpg";
// import coverSample from "../images/No_Image_Available.jpg";
// import Snapchat from "../images/snapchat.svg";
// import Facebook from "../images/facebook-icon.svg";
// import Twitter from "../images/twitter.svg";
// import Instagram from "../images/instigram.svg";
// import Global from "../images/global.svg";
// import Whatsapp from "../images/whatsapp.svg";
// import Map from "../images/map.svg";
// import Tiktok_Light from "../images/tiktok_light.svg";
// import SnapchatDarkTheme from "../images/snap-icon-dark-theme.svg";
// import FacebookDarkTheme from "../images/facebook-icon-dark-theme.svg";
// import TwitterDarkTheme from "../images/x-icon-dark-theme.svg";
// import InstagramDarkTheme from "../images/insta-icon-dark-theme.svg";
// import WhatsappDarkTheme from "../images/whatsapp-icon-dark-theme.svg";
// import MapDarkTheme from "../images/map-dark-icon-theme.svg";
// import GlobalDarkTheme from "../images/global-icon-dark-theme.svg";
// import Tiktok_Dark from "../images/tiktok_dark.svg";
// import {
// 	Box, Dialog, DialogContent, DialogTitle, FormControl,
// 	MenuItem, Select, SwipeableDrawer, Backdrop, CircularProgress,
// 	Typography,
// 	Grid,
// 	Button,
// 	AppBar,
// 	Toolbar,
// 	IconButton,
// 	Drawer,
// 	List,
// 	ListItem,
// 	ListItemIcon,
// 	ListItemText,
// 	Menu,
// 	DialogActions
// } from "@mui/material";
// import {
// 	AllLanguagesCode,
// 	generateRandomToken,
// 	getAndSaveTimeZone,
// 	getAuth,
// 	setMobileBackColor,
// 	setMobileButttonBackColor,
// 	setMobileCardBorderColor,
// 	setMobileCardColor,
// 	setMobileSettings,
// 	setMobileTextColor,
// 	setMobileTextField_BK_FONT_Border_StyleColor,

// 	FCM_TOKEN,
// 	fetchWalletBalance,
// 	getAuthMobile,
// 	getGustAuthMobile,
// 	sendNotificationFirebaseRes,
// 	ISDARKTHEME,
// 	setLocalStorageMenuItem,
// 	getLocalStorageMenuItem,
// } from "../utility";
// import { useQuery } from "react-query";
// import { useLocation, useNavigate, useParams, useSearchParams } from "react-router-dom";
// import Loading from "../common/loading";
// import "../css/mobileScreens.css";
// import i18next, { t } from "i18next";
// import { useEffect, useState } from "react";
// import ErrorDialog from "../common/errorDialog";
// import MenuAvailabilityComponent from "../components/mobile screen/mobileComponents/MenuAvailabilityComponent";
// import {
// 	ArrowLeftOutlined, ArrowRightOutlined, CloseOutlined,
// 	Person, LocationOn, Schedule, Restaurant, LocalShipping, TakeoutDining,
// 	ShoppingCart,
// 	CheckCircle,
// 	Payment,
// 	DeliveryDining,
// 	LocalDining,
// 	Home,
// 	RestaurantMenu,
// 	ContactMail,
// 	Share,
// 	ExpandMore,
// 	ChevronRight,
// 	Phone,
// 	Email,
// 	TranslateOutlined,
// 	MapOutlined
// } from "@mui/icons-material";
// import CheckOutlinedIcon from "@mui/icons-material/CheckOutlined";
// import DarkModeIcon from "@mui/icons-material/DarkMode";
// import LightModeIcon from "@mui/icons-material/LightMode";

// import MenuIcon from '@mui/icons-material/Menu';
// import CloseIcon from '@mui/icons-material/Close';
// import LoginComponent from "../components/mobile screen/mobileComponents/loginComponent";
// import { motion, useAnimation } from "framer-motion";
// import { useInView } from "react-intersection-observer";
// import { MapContainer, TileLayer, Marker, Popup } from 'react-leaflet';
// import L from 'leaflet';
// import 'leaflet/dist/leaflet.css';

// // Import your existing dialog components
// import DeliveryDialog from "../components/DeliveryDialog";
// import CurrentLocationDialog from "../components/map screens/CurrentLocationDialog";
// import NewLocationDialog from "../components/map screens/NewLocationDialog";
// import LocationFormDialog from "../components/map screens/LocationFormDialog";
// import DeleteLocationDialog from "../components/DeleteLocationDialog";
// import Toast from "../common/toast";

// // Fix for default marker icons in Leaflet
// delete L.Icon.Default.prototype._getIconUrl;
// L.Icon.Default.mergeOptions({
// 	iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png'),
// 	iconUrl: require('leaflet/dist/images/marker-icon.png'),
// 	shadowUrl: require('leaflet/dist/images/marker-shadow.png')
// });



// const WellcomeScreen = ({ tableQr, tableName }) => {
// 	const [params, setParams] = useSearchParams();
// 	const navigate = useNavigate();

// 	const [loadingTree, setLoadingTree] = useState(false);
// 	const [drawerOpen, setDrawerOpen] = useState(false);
// 	const mobileLoginToken = getLocalStorageMenuItem("mobileLoginToken") || "";
// 	const [loginDialogOpen, setLoginDialogOpen] = useState(false);
// 	const [activeSlide, setActiveSlide] = useState(0);

// 	const [customerBalance, setCustomerBalance] = useState(getLocalStorageMenuItem("customer_balance") || 0);
// 	const app_mode = getLocalStorageMenuItem("theme");

// 	// Order type state
// 	const [selectedOrderType, setSelectedOrderType] = useState(
// 		getLocalStorageMenuItem("orderType") || null
// 	);

// 	const [toastSettings, setToastSettings] = useState({
// 		open: false,
// 		message: "",
// 		success: false,
// 	});

// 	const handleOpenToast = (message, state) => {
// 		setToastSettings({
// 			open: true,
// 			success: state,
// 			message: message
// 		});
// 	};

// 	const handleCloseToast = (event, reason) => {
// 		if (reason === "clickaway") {
// 			return;
// 		}

// 		setToastSettings({ open: false, message: "", success: false });
// 	};

// 	// Delivery workflow state (using your existing structure)
// 	const [mode, setMode] = useState(null);
// 	const [selectedPlace, setSelectedPlace] = useState(null);
// 	const [placeAddress, setPlaceAddress] = useState("");
// 	const [latLangVal, setLatLangVal] = useState(null);
// 	const [isEditDelivery, setIsEditDelivery] = useState(false);
// 	const [isProcessLoading, setIsProcessLoading] = useState(false);
// 	const [deleteLocationDialogOpen, setDeleteLocationDialogOpen] = useState(false);
// 	const [deliveryDialogOpen, setDeliveryDialogOpen] = useState(false);
// 	const [openLocationFormDialog, setOpenLocationFormDialog] = useState(false);
// 	const [defaultAddress, setDefaultAddress] = useState(null);
// 	const [savedPlaces, setSavedPlaces] = useState([]);
// 	const [loadingSavedPlaces, setLoadingSavedPlaces] = useState(false);
// 	const [sideMenuOpen, setSideMenuOpen] = useState(false);

// 	// const location = useLocation();

// 	// useEffect(() => {
// 	// 	window.scrollTo(0, 0);
// 	// }, [location.pathname]);

// 	// useEffect(() => {
// 	// 	window.scrollTo({
// 	// 		top: 0,
// 	// 		behavior: 'smooth'
// 	// 	});
// 	// }, [location.pathname]);

// 	const toggleSideMenu = (open) => () => {
// 		setSideMenuOpen(open);
// 	};



// 	// Menu items data


// 	const initialLocationFormData = {
// 		title: "",
// 		street: "",
// 		unit_number: "",
// 		floor_number: "",
// 		apartment_number: "",
// 		description: "",
// 		latitude: "",
// 		longitude: "",
// 		suburb: "",
// 		city: "",
// 		province: "",
// 		state: "",
// 		postcode: "",
// 		country: ""
// 	};
// 	const themeSettings = {
// 		backColor: setMobileBackColor(),
// 		textColor: setMobileTextColor(),
// 		cardBorderColor: setMobileCardBorderColor(),
// 		buttonBackColor: setMobileButttonBackColor(),
// 		cardColor: setMobileCardColor()
// 	};

// 	const [locationFormData, setLocationFormData] = useState(initialLocationFormData);
// 	const [allTreeData, setAllTreeData] = useState(() => {
// 		const savedTreeData = getLocalStorageMenuItem("tree_data");
// 		return savedTreeData ? savedTreeData : [];
// 	});

// 	const controls = useAnimation();
// 	const [ref, inView] = useInView({
// 		threshold: 0.1,
// 		triggerOnce: false
// 	});



// 	useEffect(() => {
// 		if (inView) {
// 			controls.start("visible");
// 		} else {
// 			controls.start("hidden");
// 		}
// 	}, [controls, inView]);

// 	// Define your animation variants
// 	const scrollVariants = {
// 		hidden: {
// 			opacity: 0,
// 			y: 50,
// 			transition: { duration: 0.5 }
// 		},
// 		visible: {
// 			opacity: 1,
// 			y: 0,
// 			transition: { duration: 0.5 }
// 		}
// 	};

// 	const textOverlayVariants = {
// 		hidden: {
// 			opacity: 0,
// 			y: 20
// 		},
// 		visible: {
// 			opacity: 1,
// 			y: 0,
// 			transition: {
// 				duration: 0.8,
// 				ease: "easeOut"
// 			}
// 		}
// 	};



// 	const [showHowToOrder, setShowHowToOrder] = useState(true);

// 	const [anchorlang, setAnchorlang] = useState(null);
// 	const language = getLocalStorageMenuItem("lang");
// 	const [showInfoDailog, setShowInfoDailog] = useState(false);

// 	const openLang = Boolean(anchorlang);

// 	const howToOrderSteps = [
// 		{
// 			icon: <ShoppingCart sx={{ fontSize: 40, color: themeSettings.buttonBackColor }} />,
// 			title: t("Select Items"),
// 			description: t("Browse our menu and add items to your cart")
// 		},
// 		{
// 			icon: <CheckCircle sx={{ fontSize: 40, color: themeSettings.buttonBackColor }} />,
// 			title: t("Review Order"),
// 			description: t("Check your items and make any changes before checkout")
// 		},
// 		{
// 			icon: <Payment sx={{ fontSize: 40, color: themeSettings.buttonBackColor }} />,
// 			title: t("Make Payment"),
// 			description: t("Choose your payment method and complete your order")
// 		},
// 		{
// 			icon: <DeliveryDining sx={{ fontSize: 40, color: themeSettings.buttonBackColor }} />,
// 			title: t("Receive Order"),
// 			description: t("Pick up your order or get it delivered to your location")
// 		}
// 	];




// 	const handleOpenLoginDialog = (is_from_order) => {
// 		setLoginDialogOpen(true);
// 	};

// 	const handleCloseLoginDialog = () => {
// 		setLoginDialogOpen(false);
// 	};

// 	const handleVerificationSuccess = (token) => {
// 		if (token) {
// 			setLocalStorageMenuItem("mobileLoginToken", token || "");

// 			setLoginDialogOpen(false);

// 			if (getLocalStorageMenuItem("pendingDelivery") === "true") {
// 				setDeliveryDialogOpen(true);
// 			}
// 		}
// 	};

// 	const checkLoginToken = () => {
// 		if (mobileLoginToken && mobileLoginToken?.length > 0) {
// 			return true;
// 		}
// 		return false;
// 	}

// 	const toggleDrawer = (open) => () => {
// 		setDrawerOpen(open);
// 	};

// 	const increaseScansCount = async () => {
// 		try {
// 			const response = await axios.post(
// 				`${process.env.REACT_APP_API}/menus/${tableQr}/increase-scans-count`,
// 				getAuth()
// 			);
// 		} catch (error) {
// 			console.error("Error increasing ScansCount:", error);
// 		}
// 	};

// 	useEffect(() => {
// 		if (!getLocalStorageMenuItem("gustToken")) {
// 			setLocalStorageMenuItem("gustToken", generateRandomToken(25));
// 		}

// 		getAndSaveTimeZone();

// 		// Load saved places if user is logged in
// 		if (mobileLoginToken) {
// 			fetchSavedPlaces();
// 		}
// 	}, [mobileLoginToken]);

// 	const fetchSavedPlaces = async () => {
// 		setLoadingSavedPlaces(true);
// 		try {
// 			const [placesResponse, defaultResponse] = await Promise.all([
// 				axios.get(`${process.env.REACT_APP_API}/customer/addresses`, {
// 					headers: { Authorization: `Bearer ${mobileLoginToken}` }
// 				}),
// 				axios.get(`${process.env.REACT_APP_API}/customer/addresses/default`, {
// 					headers: { Authorization: `Bearer ${mobileLoginToken}` }
// 				})
// 			]);

// 			const defaultAddressId = defaultResponse.data.data?.id;
// 			const placesWithDefault = placesResponse.data.data.map(place => ({
// 				...place,
// 				isDefault: place.id === defaultAddressId
// 			}));

// 			setSavedPlaces(placesWithDefault);
// 			if (defaultResponse.data.data) {
// 				setDefaultAddress(defaultResponse.data.data);
// 			}
// 		} catch (error) {
// 			console.error("Error fetching addresses:", error);
// 		} finally {
// 			setLoadingSavedPlaces(false);
// 		}
// 	};

// 	const handleOrderTypeSelect = (type) => {
// 		setSelectedOrderType(type);
// 		setLocalStorageMenuItem("orderType", type);

// 		if (type === "delivery") {
// 			if (!mobileLoginToken) {
// 				setLoginDialogOpen(true);
// 				setLocalStorageMenuItem("pendingDelivery", "true");
// 			} else {
// 				setDeliveryDialogOpen(true);
// 			}
// 		} else {
// 			EnterToSections();
// 		}
// 	};

// 	const handleOptionSelect = (option) => {
// 		setMode(option);
// 	};

// 	const updateLocationFormData = (pickupMapAddress) => {
// 		setLocationFormData(prev => ({
// 			...prev,
// 			unit_number: pickupMapAddress?.house_number || "",
// 			street: pickupMapAddress?.road || "",
// 			suburb: pickupMapAddress?.suburb || pickupMapAddress?.neighbourhood || "",
// 			city: pickupMapAddress?.city || pickupMapAddress?.town || pickupMapAddress?.village || "",
// 			province: pickupMapAddress?.state || "",
// 			state: pickupMapAddress?.state || "",
// 			postcode: pickupMapAddress?.postcode || "",
// 			country: pickupMapAddress?.country || ""
// 		}));
// 	};



// 	const getDistanceAndDuration = async (start, end) => {
// 		try {
// 			const url = `https://router.project-osrm.org/route/v1/driving/${start.lng},${start.lat};${end.lng},${end.lat}?overview=false`;
// 			const response = await axios.get(url);
// 			const data = response.data;

// 			const distanceInMeters = data.routes[0].distance;
// 			const durationInSeconds = data.routes[0].duration;

// 			return {
// 				distanceInMeters,
// 				durationInSeconds
// 			};
// 		} catch (error) {
// 			console.error('Error fetching distance and duration:', error);
// 			return null;
// 		}
// 	};

// 	const handleSelectPlace = async (place, is_edit) => {
// 		setLocationFormData(place || {});
// 		setIsEditDelivery(is_edit);

// 		const venue_latitude = allTreeData?.details?.venue_latitude || 0;
// 		const venue_longitude = allTreeData?.details?.venue_longitude || 0;
// 		const selectedPlace_latitude = place?.latitude || 0;
// 		const selectedPlace_longitude = place?.longitude || 0;

// 		const distanceAndDuration = await getDistanceAndDuration(
// 			{ lat: venue_latitude, lng: venue_longitude },
// 			{ lat: selectedPlace_latitude, lng: selectedPlace_longitude }
// 		);

// 		if (distanceAndDuration) {
// 			const { distanceInMeters } = distanceAndDuration;
// 			const distanceInKm = (distanceInMeters / 1000).toFixed(2);
// 			if (distanceInKm > 20) {
// 				handleOpenToast(t("Selected location is too far (more than 20km). Please choose a closer location."), false);
// 				return;
// 			}
// 		}

// 		const addressParts = [
// 			`${t("LocationName")} ${place.title || 'NAN'}`,
// 			`${t("Street")} ${place.street || 'NAN'}`,
// 			`${t("Unit No")} ${place.unit_number || 'NAN'}`,
// 			`${t("Floor No")} ${place.floor_number || 'NAN'}`,
// 			`${t("Apartment No")} ${place.apartment_number || 'NAN'}`
// 		];

// 		setPlaceAddress(addressParts.join(", "));
// 		setSelectedPlace(place);
// 		EnterToSections();

// 		if (!is_edit) {
// 			await setDefaultAddressApi(place.id);
// 			resetLocationForm();
// 			setDeliveryDialogOpen(false);
// 		}
// 	};

// 	const setDefaultAddressApi = async (addressId) => {
// 		try {
// 			const response = await axios.post(
// 				`${process.env.REACT_APP_API}/customer/addresses/${addressId}/default`,
// 				{},
// 				{
// 					headers: {
// 						Authorization: `Bearer ${mobileLoginToken}`,
// 					},
// 				}
// 			);
// 			if (response.data.success) {
// 				setDefaultAddress(selectedPlace);
// 				// Update the saved places to reflect the new default
// 				fetchSavedPlaces();
// 			}
// 		} catch (error) {
// 			console.error("Error setting default address:", error);
// 		}
// 	};

// 	const handleSaveLocation = async () => {
// 		setIsProcessLoading(true);
// 		const newPlace = {
// 			...locationFormData,
// 			latitude: latLangVal?.lat + "",
// 			longitude: latLangVal?.lng + "",
// 		};

// 		try {
// 			const response = await axios.post(
// 				`${process.env.REACT_APP_API}/customer/addresses`,
// 				newPlace,
// 				{
// 					headers: {
// 						Authorization: `Bearer ${mobileLoginToken}`,
// 					},
// 				}
// 			);

// 			if (response.status === 200 || response.status === 201) {
// 				setMode(null);
// 				setOpenLocationFormDialog(false);
// 				resetLocationForm();
// 				fetchSavedPlaces();
// 			}
// 		} catch (error) {
// 			console.error("Error saving location:", error);
// 		} finally {
// 			setIsProcessLoading(false);
// 		}
// 	};

// 	const handleUpdateLocation = async () => {
// 		setIsProcessLoading(true);
// 		try {
// 			const response = await axios.post(
// 				`${process.env.REACT_APP_API}/customer/addresses/${locationFormData.id}`,
// 				locationFormData,
// 				{
// 					headers: {
// 						Authorization: `Bearer ${mobileLoginToken}`,
// 					},
// 				}
// 			);

// 			if (response.status === 200 || response.status === 201) {
// 				setMode(null);
// 				setOpenLocationFormDialog(false);
// 				resetLocationForm();
// 				fetchSavedPlaces();
// 			}
// 		} catch (error) {
// 			console.error("Error updating location:", error);
// 		} finally {
// 			setIsProcessLoading(false);
// 		}
// 	};

// 	const handleDeleteLocation = async () => {
// 		setIsProcessLoading(true);
// 		try {
// 			const response = await axios.delete(
// 				`${process.env.REACT_APP_API}/customer/addresses/${selectedPlace.id}`,
// 				{
// 					headers: {
// 						Authorization: `Bearer ${mobileLoginToken}`,
// 					},
// 				}
// 			);

// 			if (response.status === 200 || response.status === 201) {
// 				setMode(null);
// 				setDeleteLocationDialogOpen(false);
// 				resetLocationForm();
// 				fetchSavedPlaces();
// 			}
// 		} catch (error) {
// 			console.error("Error deleting location:", error);
// 		} finally {
// 			setIsProcessLoading(false);
// 		}
// 	};

// 	const resetLocationForm = () => {
// 		setLocationFormData(initialLocationFormData);
// 		setLatLangVal(null);
// 		setIsEditDelivery(false);
// 	};

// 	const handleCloseFormDialog = () => {
// 		setOpenLocationFormDialog(false);
// 		resetLocationForm();
// 	};

// 	const handleOpenDeleteLocationDialog = (place) => {
// 		setDeleteLocationDialogOpen(true);
// 		setSelectedPlace(place);
// 	};

// 	const handleSocialPage = (data, type) => {
// 		if (type === "whatsapp") {
// 			const phoneNumber = data.replace(/\D/g, "");
// 			const message = "";
// 			const encodedMessage = encodeURIComponent(message);
// 			window.open(`https://api.whatsapp.com/send?phone=${phoneNumber}&text=${encodedMessage}`, "_blank");
// 		} else if (type === "map") {
// 			const lat = data[0];
// 			const long = data[1];
// 			window.open(`https://www.google.com/maps/search/?api=1&query=${lat},${long}`, "_blank");
// 		} else {
// 			window.open(data, "_blank");
// 		}
// 	};

// 	const onImageError = (e) => {
// 		e.target.src = coverSample;
// 	};

// 	const {
// 		data: languageData,
// 		isLoading: languageisLoading,
// 		isError: languageIsError,
// 		error: languageErrroPublic,
// 	} = useQuery("public-languages", () => {
// 		try {
// 			return axios.get(
// 				`${process.env.REACT_APP_API}/menus/${tableQr}/public-languages`
// 			);
// 		} catch (error) { }
// 	});

// 	const handleDefaultLang = () => {
// 		const language = AllLanguagesCode.filter((lang) => {
// 			return navigator.language.includes(lang);
// 		});

// 		if (language?.length > 0) {
// 			if (params.get("lang") && params.get("lang").length > 0) {
// 				i18next.changeLanguage(params.get("lang"));
// 				document.querySelector("html").lang = params.get("lang");
// 				setLocalStorageMenuItem("lang", params.get("lang"));
// 				if (params.get("lang") === "ar" || params.get("lang") === "fa") {
// 					document.body.classList.add("arabic-font");
// 					document.body.classList.remove("latino-font");
// 				} else {
// 					document.body.classList.add("latino-font");
// 					document.body.classList.remove("arabic-font");
// 				}
// 				return params.get("lang");
// 			}
// 		}

// 		if (!getLocalStorageMenuItem("lang")) {
// 			const selectedLanguage = language[0];
// 			var checkDefaultLang = languageData?.data.data.languages?.some(language => language.code === selectedLanguage)
// 			if (checkDefaultLang) {
// 				i18next.changeLanguage(selectedLanguage);
// 				document.querySelector("html").lang = selectedLanguage;
// 				setLocalStorageMenuItem("lang", selectedLanguage);
// 				if (selectedLanguage === "ar" || selectedLanguage === "fa") {
// 					document.body.classList.add("arabic-font");
// 					document.body.classList.remove("latino-font");
// 				} else {
// 					document.body.classList.add("latino-font");
// 					document.body.classList.remove("arabic-font");
// 				}
// 				return selectedLanguage;
// 			} else {
// 				i18next.changeLanguage(languageData?.data?.data?.languages[0]?.code);
// 				document.querySelector("html").lang = languageData?.data?.data?.languages[0]?.code;
// 				setLocalStorageMenuItem("lang", languageData?.data?.data?.languages[0]?.code);

// 				if (languageData?.data?.data?.languages[0]?.code === "ar" || languageData?.data?.data?.languages[0]?.code === "fa") {
// 					document.body.classList.add("arabic-font");
// 					document.body.classList.remove("latino-font");
// 				} else {
// 					document.body.classList.add("latino-font");
// 					document.body.classList.remove("arabic-font");
// 				}

// 				return languageData?.data?.data?.languages[0]?.code;
// 			}

// 		} else {
// 			return getLocalStorageMenuItem("lang");
// 		}
// 	};

// 	const handleLanguage = (event) => {
// 		const lang = event.target.value;
// 		i18next.changeLanguage(lang);
// 		document.querySelector("html").lang = lang;
// 		setLocalStorageMenuItem("lang", lang);
// 		params.set("lang", lang);

// 		if (lang === "ar" || lang === "fa") {
// 			document.body.classList.add("arabic-font");
// 			document.body.classList.remove("latino-font");
// 		} else {
// 			document.body.classList.add("latino-font");
// 			document.body.classList.remove("arabic-font");
// 		}
// 		setParams(params);
// 	};

// 	const handleClickLang = (event) => {
// 		setAnchorlang(event.currentTarget);
// 	};

// 	const handleCloseLang = () => {
// 		setAnchorlang(null);
// 	};

// 	const handleLanguagedata = async (langCode) => {
// 		setLoadingTree(true);
// 		try {
// 			const timeZone = getLocalStorageMenuItem("timezone") || "";
// 			const promise = await axios.get(
// 				`${process.env.REACT_APP_API}/menus/${tableQr}/public-tree`,
// 				{
// 					headers: {
// 						localization: langCode,
// 						timeZone: timeZone.replace(/["]+/g, ""),
// 					},
// 				}
// 			);
// 			await setLocalStorageMenuItem(
// 				"tree_data",
// 				JSON.stringify(promise?.data?.data ? promise?.data?.data : [])
// 			);
// 			i18next.changeLanguage(langCode);
// 			document.querySelector("html").lang = langCode;
// 			setLocalStorageMenuItem("lang", langCode);
// 			params.set("lang", langCode);
// 			setParams(params);

// 			if (langCode === "ar" || langCode === "fa") {
// 				document.body.classList.add("arabic-font");
// 				document.body.classList.remove("latino-font");
// 			} else {
// 				document.body.classList.add("latino-font");
// 				document.body.classList.remove("arabic-font");
// 			}
// 		} catch (error) {
// 		} finally {
// 			setLoadingTree(false);
// 		}
// 	};

// 	const {
// 		data: treeData,
// 		isLoading: treeDataIsLoading,
// 		isFetching: treeDataIsFetching,
// 		isError: treeDataIsError,
// 		error: treeDataError,
// 		refetch,
// 	} = useQuery("treeData", async () => {
// 		try {
// 			const language = AllLanguagesCode.filter((lang) => {
// 				return navigator.language.includes(lang);
// 			});
// 			var requestLang = "";

// 			const langData = await axios.get(
// 				`${process.env.REACT_APP_API}/menus/${tableQr}/public-languages`
// 			);

// 			if (!getLocalStorageMenuItem("lang")) {
// 				const selectedLanguage = language[0];
// 				var checkDefaultLang = langData?.data.data.languages?.some(language => language.code === selectedLanguage)
// 				if (checkDefaultLang) {
// 					requestLang = selectedLanguage;
// 				} else {
// 					requestLang = langData?.data?.data?.languages[0]?.code;
// 				}

// 			} else {
// 				requestLang = getLocalStorageMenuItem("lang");
// 			}

// 			const timeZone = getLocalStorageMenuItem("timezone") ? getLocalStorageMenuItem("timezone") : "";
// 			const promise = await axios.get(
// 				`${process.env.REACT_APP_API}/menus/${tableQr}/public-tree`,
// 				{
// 					headers: {
// 						localization: requestLang || getLocalStorageMenuItem("lang"),
// 						timeZone: timeZone.replace(/["]+/g, '')
// 					}
// 				}
// 			);
// 			if (promise.status === 200) {
// 				setLocalStorageMenuItem(
// 					"tree_data", JSON.stringify(promise?.data?.data ? promise?.data?.data : [])
// 				);
// 				setMobileSettings(promise?.data?.data?.details)
// 			}
// 			return promise;
// 		} catch (error) { }
// 	});

// 	if (treeDataError || languageIsError) {
// 		return <ErrorDialog />;
// 	}

// 	if (languageisLoading || treeDataIsLoading || loadingTree) {
// 		return <Loading backColor={setMobileBackColor()} />;
// 	}

// 	const EnterToSections = () => {
// 		navigate(
// 			`/${tableName}/${tableQr}/sections?section=0&t=${params.get(
// 				"t"
// 			)}&lang=${getLocalStorageMenuItem("lang")}`
// 		);
// 		increaseScansCount();
// 	}

// 	const navigateToPhoneNumberVerification = () => {
// 		navigate(`/${tableName}/${tableQr}/verify-phone?t=${params.get(
// 			"t"
// 		)}&lang=${getLocalStorageMenuItem("lang")}`);
// 	};

// 	// Animation variants
// 	const fadeIn = {
// 		hidden: { opacity: 0 },
// 		visible: { opacity: 1, transition: { duration: 0.8 } }
// 	};

// 	const slideUp = {
// 		hidden: { y: 50, opacity: 0 },
// 		visible: { y: 0, opacity: 1, transition: { duration: 0.6 } }
// 	};

// 	const venueLocation = {
// 		lat: parseFloat(treeData?.data?.data?.details?.venue_latitude) || 0,
// 		lng: parseFloat(treeData?.data?.data?.details?.venue_longitude) || 0
// 	};

// 	const menuItems = [

// 		{
// 			text: t('Browse Menu'),
// 			icon: <RestaurantMenu />,
// 			action: EnterToSections
// 		},
// 		{
// 			text: t('Opening hours'),
// 			icon: <Schedule />,
// 			action: () => {
// 				setSideMenuOpen(false);
// 				setDrawerOpen(true);
// 			}
// 		},
// 		{
// 			text: t('Contact Us'),
// 			icon: <ContactMail />,
// 			action: () => window.location.href = `tel:${treeData?.data?.data?.details?.whatsapp}`
// 		},
// 		{
// 			text: t('Follow Us'),
// 			icon: <Share />,
// 			action: null, // This will be handled in sub-items
// 			subItems: [
// 				treeData?.data?.data?.details?.facebook && {
// 					text: t('Facebook'),
// 					icon: <img
// 						src={getLocalStorageMenuItem("theme") !== "light" ? FacebookDarkTheme : Facebook}
// 						alt="Facebook"
// 						style={{ width: 24, height: 24 }}
// 					/>,
// 					action: () => handleSocialPage(treeData?.data?.data?.details?.facebook, 'facebook')
// 				},
// 				treeData?.data?.data?.details?.instagram && {
// 					text: t('Instagram'),
// 					icon: <img
// 						src={getLocalStorageMenuItem("theme") !== "light" ? InstagramDarkTheme : Instagram}
// 						alt="Instagram"
// 						style={{ width: 24, height: 24 }}
// 					/>,
// 					action: () => handleSocialPage(treeData?.data?.data?.details?.instagram, 'instagram')
// 				},
// 				treeData?.data?.data?.details?.twitter && {
// 					text: t('Twitter'),
// 					icon: <img
// 						src={getLocalStorageMenuItem("theme") !== "light" ? TwitterDarkTheme : Twitter}
// 						alt="Twitter"
// 						style={{ width: 24, height: 24 }}
// 					/>,
// 					action: () => handleSocialPage(treeData?.data?.data?.details?.twitter, 'twitter')
// 				},
// 				treeData?.data?.data?.details?.snapchat && {
// 					text: 'Snapchat',
// 					icon: <img
// 						src={getLocalStorageMenuItem("theme") !== "light" ? SnapchatDarkTheme : Snapchat}
// 						alt="Snapchat"
// 						style={{ width: 24, height: 24 }}
// 					/>,
// 					action: () => handleSocialPage(treeData?.data?.data?.details?.snapchat, 'snapchat')
// 				},
// 				treeData?.data?.data?.details?.public_whatsapp && {
// 					text: t('WhatsApp'),
// 					icon: <img
// 						src={getLocalStorageMenuItem("theme") !== "light" ? WhatsappDarkTheme : Whatsapp}
// 						alt="WhatsApp"
// 						style={{ width: 24, height: 24 }}
// 					/>,
// 					action: () => handleSocialPage(treeData?.data?.data?.details?.public_whatsapp, 'whatsapp')
// 				},
// 				treeData?.data?.data?.details?.tiktok && {
// 					text: t('TikTok'),
// 					icon: <img
// 						src={getLocalStorageMenuItem("theme") !== "light" ? Tiktok_Dark : Tiktok_Light}
// 						alt="TikTok"
// 						style={{ width: 24, height: 24 }}
// 					/>,
// 					action: () => handleSocialPage(treeData?.data?.data?.details?.tiktok, 'tiktok')
// 				},
// 				treeData?.data?.data?.details?.website && {
// 					text: t('Website'),
// 					icon: <img
// 						src={getLocalStorageMenuItem("theme") !== "light" ? GlobalDarkTheme : Global}
// 						alt="Website"
// 						style={{ width: 24, height: 24 }}
// 					/>,
// 					action: () => handleSocialPage(treeData?.data?.data?.details?.website, 'website')
// 				},
// 				(treeData?.data?.data?.details?.latitude && treeData?.data?.data?.details?.longitude) && {
// 					text: t('Location'),
// 					icon: <img
// 						src={getLocalStorageMenuItem("theme") !== "light" ? MapDarkTheme : Map}
// 						alt="Location"
// 						style={{ width: 24, height: 24 }}
// 					/>,
// 					action: () => handleSocialPage(
// 						[treeData?.data?.data?.details?.latitude, treeData?.data?.data?.details?.longitude],
// 						'map'
// 					)
// 				},
// 				treeData?.data?.data?.details?.phone && {
// 					text: t('Call Us'),
// 					icon: <Phone style={{ color: setMobileTextColor(), width: 24, height: 24 }} />,
// 					action: () => window.location.href = `tel:${treeData?.data?.data?.details?.phone}`
// 				},
// 				treeData?.data?.data?.details?.email && {
// 					text: t('Email Us'),
// 					icon: <Email style={{ color: setMobileTextColor(), width: 24, height: 24 }} />,
// 					action: () => window.location.href = `mailto:${treeData?.data?.data?.details?.email}`
// 				}
// 			].filter(Boolean)
// 		}
// 	];

// 	const handleClickNavigation = async (dist) => {
// 		const language = getLocalStorageMenuItem("lang");
// 		if (dist == "profile") {
// 			const baseUrl = `/${tableName}/${tableQr}/profile?lang=${language}`;
// 			const tableParam = params.get("t");
// 			navigate(tableParam ? `${baseUrl}&t=${tableParam}` : baseUrl);
// 		} else if (dist === "orders") {
// 			navigate(
// 				`/${tableName}/${tableQr}/orders?section=0&t=${params.get(
// 					"t"
// 				)}&lang=${language}`
// 			);
// 		} else if (dist === "transactions") {
// 			navigate(
// 				`/${tableName}/${tableQr}/transactions?section=0&t=${params.get(
// 					"t"
// 				)}&lang=${language}`
// 			);
// 		} else if (dist === "favorites") {
// 			navigate(
// 				`/${tableName}/${tableQr}/favorites?section=0&t=${params.get("t")}`
// 			);
// 		} else if (dist === "feedback") {
// 			navigate(
// 				`/${tableName}/${tableQr}/feedback?section=0&t=${params.get("t")}`
// 			);
// 		} else if (dist === "privacy") {
// 			navigate(`/${tableName}/${tableQr}/privacy-policy`);
// 		} else if (dist === "terms") {
// 			navigate(`/${tableName}/${tableQr}/terms-and-conditions`);
// 		} else if (dist === "logout") {
// 			await setLocalStorageMenuItem("mobileLoginToken", "");
// 			const baseUrl = `/${tableName}/${tableQr}/menus?lang=${language}`;
// 			const tableParam = params.get("t");
// 			navigate(tableParam ? `${baseUrl}&t=${tableParam}` : baseUrl);
// 		}
// 	}

// 	const hanldeMode = () => {
// 		if (getLocalStorageMenuItem("theme") === "dark") {
// 			setLocalStorageMenuItem("theme", "light");
// 			params.set("theme", "light");
// 			setParams(params);
// 		} else {
// 			setLocalStorageMenuItem("theme", "dark");
// 			params.set("theme", "dark");
// 			setParams(params);
// 		}
// 	};


// 	const handleSendNotification = async (title, body) => {
// 		setIsProcessLoading(true);
// 		try {
// 			const sendNotificationRes = await axios.post(
// 				`${process.env.REACT_APP_API}/general-notification`,
// 				{
// 					venue_id: treeData?.data?.data?.details?.venue_id,
// 					title: title || "",
// 					message: body || "",
// 					table: params.get("t") || "",
// 				}
// 			);

// 			const sendNotificationFirebase = await sendNotificationFirebaseRes(
// 				treeData?.data?.data?.details,
// 				title || "",
// 				body || "",
// 				"notifications"
// 			);

// 			if (
// 				sendNotificationRes?.data?.success &&
// 				sendNotificationFirebase?.data?.success
// 			) {
// 				setIsProcessLoading(false);

// 				// handleOpenToast(
// 				//   <div className="alignByLang">
// 				//     {t("Your notification sent successfully")}
// 				//   </div>
// 				//   , true);

// 				setShowInfoDailog(true);
// 			} else {
// 				setIsProcessLoading(false);

// 				handleOpenToast(
// 					<div className="alignByLang">
// 						{t("Error while sending the notification.")}
// 					</div>
// 					, false);
// 			}
// 		} catch (error) {
// 			setIsProcessLoading(false);

// 			handleOpenToast(
// 				<div className="alignByLang">
// 					{t("Error while sending the notification.") + " " + error.message}
// 				</div>
// 				, false);
// 		}
// 	};

// 	const dialogStyles = {
// 		backgroundColor: setMobileTextField_BK_FONT_Border_StyleColor()[0],
// 		color: setMobileTextField_BK_FONT_Border_StyleColor()[1],
// 		borderColor: setMobileTextField_BK_FONT_Border_StyleColor()[2],
// 	};

// 	return (
// 		<div
// 			className={`min-vh-100`}
// 			style={{
// 				backgroundColor:
// 					getLocalStorageMenuItem("theme") === "dark" ||
// 						getLocalStorageMenuItem("theme") === "costomize"
// 						? setMobileBackColor()
// 						: "",
// 				backgroundImage:
// 					getLocalStorageMenuItem("theme") === "dark" ||
// 						getLocalStorageMenuItem("theme") === "costomize"
// 						? setMobileBackColor()
// 						: "",
// 			}}
// 		>

// 			<AppBar className="alignByLang" position="sticky" elevation={0} sx={{
// 				backgroundColor:
// 					getLocalStorageMenuItem("theme") === "dark" ||
// 						getLocalStorageMenuItem("theme") === "costomize"
// 						? setMobileBackColor()
// 						: "",

// 				boxShadow: 'none',
// 				padding: '8px 16px',
// 				position: 'sticky',
// 				top: 0,
// 				left: 0,
// 				right: 0,
// 				zIndex: 1000
// 			}}>
// 				<Toolbar sx={{ justifyContent: 'space-between', padding: '0 !important' }}>
// 					{/* Hamburger Menu Icon */}
// 					<IconButton
// 						edge="end"
// 						color="inherit"
// 						aria-label="menu"
// 						onClick={toggleSideMenu(true)}
// 						sx={{
// 							color: setMobileTextColor(),
// 							backgroundColor: 'rgba(255, 255, 255, 0.1)',
// 							borderRadius: '8px',
// 							padding: '8px',
// 							'&:hover': {
// 								backgroundColor: 'rgba(255, 255, 255, 0.2)'
// 							}
// 						}}
// 					>
// 						<MenuIcon />
// 					</IconButton>

// 					<motion.div>
// 						{getLocalStorageMenuItem("mobileLoginToken") && (
// 							<div className="mt-2 text-center" style={{ color: setMobileTextColor() }}>
// 								<div className="sub-font alignByLang text-center">
// 									{t("Welcome")} {getLocalStorageMenuItem("customer_name")}
// 								</div>
// 							</div>
// 						)}
// 					</motion.div>

// 					{/* Logo */}
// 					<motion.div whileHover={{ scale: 1.05 }}>
// 						<img
// 							src={treeData?.data?.data?.details?.logo || no_image}
// 							style={{ height: '40px', maxWidth: '150px', objectFit: 'contain', borderRadius: '20px' }}
// 							onError={onImageError}
// 							alt="Venue Logo"
// 						/>
// 					</motion.div>

// 				</Toolbar>
// 			</AppBar>

// 			<Drawer
// 				anchor={getLocalStorageMenuItem("lang") === "ar" ? "right" : "left"}
// 				open={sideMenuOpen}
// 				onClose={toggleSideMenu(false)}
// 				sx={{
// 					'& .MuiDrawer-paper': {
// 						width: 350,
// 						backgroundColor: setMobileBackColor(),
// 						color: setMobileTextColor(),
// 					}
// 				}}
// 				className="alignByLang"
// 			>

// 				<div
// 					className={`mobile-side-bar min-vh-100`}
// 					style={{
// 						color: setMobileTextColor(),
// 						backgroundColor: setMobileCardColor(),
// 					}}
// 				>
// 					<div className="d-flex justify-content-between mobile-side-bar-top-settings p-4 sub-font">
// 						{/* <img
// 							  src={treeData?.data?.data?.details?.logo || noImageAvailable}
// 							  alt="logo"
// 							  style={{ border: `4px solid ${setMobileCardColor()} ` }}
// 							  className="mobile-side-bar-logo"
// 							  onError={onImageError}
// 							/> */}

// 						<div>
// 							<img
// 								src={treeData?.data?.data?.details?.logo || no_image}
// 								alt="logo"
// 								style={{ border: `4px solid ${setMobileCardColor()} ` }}
// 								className="mobile-side-bar-logo"
// 								onError={onImageError}
// 							/>
// 							{/* Add name and balance from localStorage */}

// 							{getLocalStorageMenuItem("mobileLoginToken") && (
// 								<div className="mt-2 text-center" style={{ color: setMobileTextColor() }}>
// 									<div className="sub-font alignByLang text-center">
// 										{t("Welcome")} {getLocalStorageMenuItem("customer_name")}
// 									</div>
// 									<div className="sub-font alignByLang text-center">
// 										{t("Your Balance")} : {customerBalance}
// 									</div>
// 								</div>
// 							)}
// 						</div>


// 						<div className="d-flex justify-content-between">
// 							<div>
// 								<span
// 									className="mx-2 pt-0 cursor"
// 									onClick={toggleSideMenu(false)}
// 								>
// 									<CloseOutlined style={{ color: setMobileTextColor() }} />
// 								</span>
// 								<span className="mx-2 pt-0 cursor" onClick={handleClickLang}>
// 									<TranslateOutlined style={{ color: setMobileTextColor() }} />
// 								</span>
// 								<Menu
// 									id="long-menu"
// 									MenuListProps={{
// 										"aria-labelledby": "long-button",
// 									}}
// 									anchorEl={anchorlang}
// 									open={openLang}
// 									onClose={handleCloseLang}
// 									onClick={handleCloseLang}
// 									PaperProps={{
// 										style: {
// 											maxHeight: 48 * 4.5,
// 											width: "25ch",
// 											backgroundColor: setMobileBackColor(),
// 										},
// 									}}
// 								>
// 									{languageData?.data?.data?.languages?.map((lang) => (
// 										<MenuItem
// 											key={lang.code}
// 											onClick={() => handleLanguagedata(lang?.code || "en")}
// 										>
// 											<li
// 												className="d-flex justify-content-between align-items-center p-1 sub-font"
// 												style={{
// 													color:
// 														language === lang.code
// 															? setMobileButttonBackColor()
// 															: setMobileTextColor(),
// 												}}
// 											>
// 												<span style={{ maxWidth: "80%" }}>
// 													{` ${lang.label} ( ${lang.label} ) `}
// 												</span>
// 												<span
// 													style={{ maxWidth: "10%" }}
// 													className={`${language === lang.code ? "d-block" : "d-none"
// 														}`}
// 												>
// 													<CheckOutlinedIcon />
// 												</span>
// 											</li>
// 										</MenuItem>
// 									))}
// 								</Menu>
// 							</div>
// 							<div>
// 								{getLocalStorageMenuItem("theme") !== "costomize" && (
// 									<span className="ms-2 pt-0 cursor" onClick={hanldeMode}>
// 										{app_mode === "dark" ? (
// 											<DarkModeIcon className="mode-icon-dark" />
// 										) : (
// 											<LightModeIcon className="mode-icon-light" />
// 										)}
// 									</span>
// 								)}
// 							</div>
// 						</div>
// 					</div>

// 					{loadingTree && <Loading backColor={setMobileBackColor()} />}

// 					<div className="p-24">
// 						<div
// 							className="rounded-4 m-top-12 pt-3 pb-3 px-3 alignByLang"
// 							style={{
// 								backgroundColor: setMobileBackColor(),
// 								borderColor: setMobileCardBorderColor(),
// 								borderWidth: 1,
// 								borderStyle: "solid",
// 							}}
// 						>
// 							{JSON.parse(params.get("t")) && (
// 								<>
// 									<Badge
// 										onClick={() =>
// 											handleSendNotification(
// 												"call waiter",
// 												"please call waiter for this table"

// 											)
// 										}
// 										style={{
// 											borderRadius: "8px",
// 										}}
// 										className={`outofinstock-badge-dish-style font-size-14 sub-font m-1`}
// 									>
// 										{t("Call Waiter")}
// 									</Badge>

// 									{treeData?.data?.data?.details?.notification_buttons_settings
// 										?.notification_1_active && (
// 											<Badge
// 												onClick={() =>
// 													handleSendNotification(
// 														treeData?.data?.data?.details?.notification_buttons_settings
// 															?.notification_1_title,
// 														treeData?.data?.data?.details?.notification_buttons_settings
// 															?.notification_1_body
// 													)
// 												}
// 												style={{
// 													borderRadius: "8px",
// 												}}
// 												className={`outofinstock-badge-dish-style font-size-14 sub-font m-1`}
// 											>
// 												{t(
// 													treeData?.data?.data?.details?.notification_buttons_settings
// 														?.notification_1_button
// 												) || ""}
// 											</Badge>
// 										)}

// 									{treeData?.data?.data?.details?.notification_buttons_settings
// 										?.notification_2_active && (
// 											<Badge
// 												onClick={() =>
// 													handleSendNotification(
// 														treeData?.data?.data?.details?.notification_buttons_settings
// 															?.notification_2_title,
// 														treeData?.data?.data?.details?.notification_buttons_settings
// 															?.notification_2_body
// 													)
// 												}
// 												style={{
// 													borderRadius: "8px",
// 												}}
// 												className={`outofinstock-badge-dish-style font-size-14 sub-font m-1`}
// 											>
// 												{t(
// 													treeData?.data?.data?.details?.notification_buttons_settings
// 														?.notification_2_button
// 												) || ""}
// 											</Badge>
// 										)}
// 								</>
// 							)}



// 							{getLocalStorageMenuItem("mobileLoginToken") &&
// 								getLocalStorageMenuItem("mobileLoginToken")?.length > 0 ? (
// 								<p className="m-top-12 cursor head-font" onClick={() => handleClickNavigation("profile")}>
// 									{t("My Profile")}
// 								</p>
// 							) : (
// 								""
// 							)}

// 							{allTreeData?.details?.order_ability && getLocalStorageMenuItem("mobileLoginToken") ? (
// 								<p onClick={() => handleClickNavigation("orders")} className="cursor head-font">
// 									{t("My orders")}
// 								</p>
// 							) : (
// 								""
// 							)}

// 							{getLocalStorageMenuItem("mobileLoginToken") &&
// 								getLocalStorageMenuItem("mobileLoginToken")?.length > 0 ? (
// 								<p className="m-top-12 cursor head-font" onClick={() => handleClickNavigation("transactions")}>
// 									{t("Wallet")}
// 								</p>
// 							) : (
// 								""
// 							)}

// 							<p className="m-top-12 cursor head-font" onClick={() => handleClickNavigation("favorites")}>
// 								{t("Favorites")}
// 							</p>

// 							<p onClick={() => handleClickNavigation("feedback")} className="cursor head-font">
// 								{t("Your opinion Matters!")}
// 							</p>

// 							<p onClick={() => handleClickNavigation("privacy")} className="cursor head-font">
// 								{t("Privacy Policy")}
// 							</p>

// 							<p onClick={() => handleClickNavigation("terms")} className="cursor head-font">
// 								{t("Terms and Conditions")}
// 							</p>

// 							{getLocalStorageMenuItem("mobileLoginToken") &&
// 								getLocalStorageMenuItem("mobileLoginToken")?.length > 0 ? (
// 								<p onClick={() => handleClickNavigation("logout")} className="cursor head-font">
// 									{t("Logout")}
// 								</p>
// 							) : (
// 								""
// 							)}
// 						</div>
// 					</div>
// 					<div style={{ borderBottom: "1px solid #aaa" }}></div>
// 				</div>

// 				<ul className="position-absolute mb-4 bottom-0 start-0 w-100 d-flex justify-content-center list-unstyled">
// 					{treeData?.data?.data?.details?.facebook && (
// 						<li className="mx-2">
// 							<img
// 								onClick={() => handleSocialPage(treeData?.data?.data?.details?.facebook)}
// 								src={Facebook}
// 								alt="Facebook icon"
// 								className="cursor"
// 							/>
// 						</li>
// 					)}
// 					{treeData?.data?.data?.details?.instagram && (
// 						<li className="mx-2">
// 							<img
// 								onClick={() => handleSocialPage(treeData?.data?.data?.details?.instagram)}
// 								src={Instagram}
// 								alt="Instagram icon"
// 								className="cursor"
// 							/>
// 						</li>
// 					)}
// 					{treeData?.data?.data?.details?.twitter && (
// 						<li className="mx-2">
// 							<img
// 								onClick={() => handleSocialPage(treeData?.data?.data?.details?.twitter)}
// 								src={Twitter}
// 								alt="X icon"
// 								className="cursor"
// 							/>
// 						</li>
// 					)}
// 					{treeData?.data?.data?.details?.snapchat && (
// 						<li className="mx-2">
// 							<img
// 								onClick={() => handleSocialPage(treeData?.data?.data?.details?.snapchat)}
// 								src={Snapchat}
// 								alt="Snapchat icon"
// 								className="cursor"
// 							/>
// 						</li>
// 					)}
// 					{treeData?.data?.data?.details?.website && (
// 						<li className="mx-2">
// 							<img
// 								onClick={() => handleSocialPage(treeData?.data?.data?.details?.website)}
// 								src={Global}
// 								alt="global icon"
// 								className="cursor"
// 							/>
// 						</li>
// 					)}
// 				</ul>

// 			</Drawer>

// 			<div className="row p-0 m-0">
// 				<div className="col-lg-8 d-none d-lg-block">
// 					<div className="mt-5 text-center d-flex-justify-content-center align-items-center">
// 						<div style={{ marginTop: "15%", left: "25%", position: "fixed" }}>
// 							<motion.img
// 								src={treeData?.data?.data?.details?.logo || no_image}
// 								className="me-4 slider-mobile-logo"
// 								style={{ width: "250px", height: "250px" }}
// 								onError={onImageError}

// 								animate="visible"
// 								initial="hidden"
// 								whileInView="visible"

// 								variants={scrollVariants}
// 							/>
// 							<motion.h1
// 								className="mt-4 head-font"
// 								style={{ color: setMobileTextColor() }}

// 								animate="visible"
// 								initial="hidden"
// 								whileInView="visible"

// 								variants={scrollVariants}
// 							>
// 								{treeData?.data?.data?.details?.venu_name}
// 							</motion.h1>
// 						</div>
// 					</div>
// 				</div>
// 				<div className="col-lg-4 ms-auto p-0">
// 					<motion.div
// 						initial="hidden"
// 						whileInView="visible"

// 						variants={scrollVariants}
// 						className="text-center"

// 						animate="visible"
// 					>

// 						<div className="slider-mobile" style={{ position: 'relative' }}>
// 							<img
// 								src={
// 									treeData?.data?.data?.details?.cover
// 										? treeData?.data?.data?.details?.cover
// 										: no_image
// 								}
// 								onError={onImageError}
// 								className="slider-mobile-image"
// 							/>

// 							{(treeData?.data?.data?.details?.is_available && !checkLoginToken()) && (
// 								<motion.div
// 									initial="hidden"
// 									whileInView="visible"
// 									variants={scrollVariants}
// 									whileHover={{ scale: 1.1 }}
// 									style={{
// 										position: 'absolute',
// 										bottom: '20px',
// 										[getLocalStorageMenuItem("lang") === "ar" ? 'right' : 'left']: '20px',
// 										zIndex: 10
// 									}}
// 								>
// 									<Button
// 										variant="outlined"
// 										disabled={!treeData?.data?.data?.details?.is_available || checkLoginToken()}
// 										className="m-top-12 head-font"
// 										onClick={() => handleOpenLoginDialog()}
// 										style={{
// 											color: setMobileTextColor(),
// 											backgroundColor: 'rgba(0, 0, 0, 0.5)',
// 											borderColor: setMobileTextColor(),
// 											borderRadius: '50%',
// 											width: '50px',
// 											height: '50px',
// 											minWidth: 'unset',
// 											padding: 0
// 										}}
// 									>
// 										<Person style={{ color: setMobileTextColor() }} />
// 									</Button>
// 								</motion.div>
// 							)}

// 							{/* Text Overlay */}
// 							<motion.div
// 								ref={ref}
// 								initial={{ opacity: 0, y: 20 }}
// 								animate={inView ? { opacity: 1, y: 0 } : {}}
// 								transition={{ duration: 0.8, delay: 0.2, ease: "easeOut" }}
// 								style={{
// 									position: 'absolute',
// 									bottom: '20%',
// 									left: 0,
// 									right: 0,
// 									textAlign: 'center',
// 									padding: '0 20px',
// 									color: 'white',
// 									textShadow: '0 2px 4px rgba(0,0,0,0.5)'
// 								}}
// 							>
// 								<Typography
// 									variant="h3"
// 									style={{
// 										fontWeight: 'bold',
// 										fontSize: '2.5rem',
// 										marginBottom: '1rem'
// 									}}
// 								>
// 									{treeData?.data?.data?.details?.venu_name}
// 								</Typography>
// 							</motion.div>
// 						</div>

// 					</motion.div>


// 					<div className="wellcomeScreen" style={{ marginTop: 10 }} >
// 						<Container style={{ padding: 0 }}>
// 							<motion.div
// 								initial="hidden"
// 								whileInView="visible"

// 								variants={scrollVariants}
// 								className="text-center"
// 								// style={{ paddingLeft: "24px", paddingRight: "24px" }}

// 								animate="visible"
// 							>
// 								<h1
// 									className="mb-2 head-font"
// 									style={{ color: setMobileTextColor() }}
// 								>
// 									{getLocalStorageMenuItem("tree_data")?.details?.venu_name || treeData?.data?.data?.details?.venu_name}
// 								</h1>
// 								<p className="head-font" style={{ color: setMobileTextColor() }}>
// 									{getLocalStorageMenuItem("tree_data")?.details?.description || treeData?.data?.data?.details?.description}
// 								</p>


// 								{/* Order Type Buttons with Enhanced UI */}
// 								<motion.div
// 									initial="hidden"
// 									whileInView="visible"

// 									variants={scrollVariants}
// 									style={{ margin: '16px 0' }}

// 									animate="visible"
// 								>
// 									<div style={{
// 										borderRadius: '12px',
// 										padding: '16px',
// 										marginBottom: '24px',
// 										marginLeft: '24px',
// 										marginRight: '24px',
// 										backgroundColor: themeSettings.cardColor,
// 										border: `1px solid ${themeSettings.cardBorderColor}`,
// 										boxShadow: `0 4px 12px ${themeSettings.cardBorderColor}40`,
// 										transition: 'all 0.3s ease',
// 										'&:hover': {
// 											boxShadow: `0 8px 24px ${themeSettings.cardBorderColor}60`
// 										}
// 									}}>
// 										<motion.div
// 											initial="hidden"
// 											whileInView="visible"

// 											variants={scrollVariants} whileHover={{ scale: 1.05 }}>
// 											<Restaurant style={{
// 												fontSize: '20px',
// 												color: themeSettings.cardBorderColor,
// 												marginBottom: 2
// 											}} />
// 											<Typography
// 												variant="subtitle1"
// 												style={{
// 													color: themeSettings.textColor,
// 													marginBottom: '16px',
// 													fontWeight: 600 // Made the title slightly bolder
// 												}}
// 											>
// 												{t("Select Order Type")}
// 											</Typography>
// 										</motion.div>

// 										<div style={{
// 											display: 'flex',
// 											flexDirection: 'row',
// 											alignItems: 'center',
// 											justifyContent: 'center',
// 											gap: '8px',
// 											marginBottom: '12px',
// 											flexWrap: 'wrap',
// 										}}>
// 											{treeData?.data?.data?.details?.is_dinein_active && params.get("t") && params.get("t") !== "null" ? (
// 												<>
// 													<motion.div
// 														initial="hidden"
// 														whileInView="visible"

// 														variants={scrollVariants} whileHover={{ scale: 1.05 }}>
// 														<Button
// 															variant="contained"
// 															onClick={() => handleOrderTypeSelect("dinein")}
// 															style={{
// 																backgroundColor: themeSettings.buttonBackColor,
// 																color: '#fff',
// 																borderRadius: '8px',
// 																fontWeight: 600,
// 																textTransform: 'none',
// 																fontSize: '14px',
// 																width: '110px',
// 																padding: '8px 8px',
// 																boxShadow: '0 4px 8px rgba(0,0,0,0.2)', // Enhanced button shadow
// 																transition: 'all 0.2s ease',
// 																'&:hover': {
// 																	transform: 'translateY(-2px)',
// 																	boxShadow: '0 6px 12px rgba(0,0,0,0.3)'
// 																}
// 															}}
// 															startIcon={<Restaurant style={{ fontSize: '24px' }} />}
// 														>
// 															{t("Dine In")}
// 														</Button>
// 													</motion.div>

// 												</>
// 											) : (
// 												<>
// 													{treeData?.data?.data?.details?.is_pickup_active ? (
// 														<>
// 															<motion.div
// 																initial="hidden"
// 																whileInView="visible"

// 																variants={scrollVariants} whileHover={{ scale: 1.05 }}>
// 																<Button
// 																	variant="contained"
// 																	onClick={() => handleOrderTypeSelect("pickup")}
// 																	style={{
// 																		backgroundColor: themeSettings.buttonBackColor,
// 																		color: '#fff',
// 																		borderRadius: '8px',
// 																		fontWeight: 600,
// 																		textTransform: 'none',
// 																		fontSize: '14px',
// 																		width: '110px',
// 																		padding: '8px 8px',
// 																		boxShadow: '0 4px 8px rgba(0,0,0,0.2)', // Enhanced button shadow
// 																		transition: 'all 0.2s ease',
// 																		'&:hover': {
// 																			transform: 'translateY(-2px)',
// 																			boxShadow: '0 6px 12px rgba(0,0,0,0.3)'
// 																		}
// 																	}}
// 																	startIcon={<LocalDining style={{ fontSize: '24px' }} />}
// 																>
// 																	{t("Pickup")}
// 																</Button>
// 															</motion.div>

// 														</>
// 													) : (
// 														<></>
// 													)}

// 													{treeData?.data?.data?.details?.is_delivery_active ? (
// 														<motion.div
// 															initial="hidden"
// 															whileInView="visible"

// 															variants={scrollVariants} whileHover={{ scale: 1.05 }}>
// 															<Button

// 																variant="contained"
// 																onClick={() => handleOrderTypeSelect("delivery")}
// 																style={{
// 																	backgroundColor: themeSettings.buttonBackColor,
// 																	color: '#fff',
// 																	borderRadius: '8px',
// 																	fontWeight: 600,
// 																	textTransform: 'none',
// 																	fontSize: '14px',
// 																	width: '110px',

// 																	padding: '8px 8px',
// 																	boxShadow: '0 4px 8px rgba(0,0,0,0.2)', // Enhanced button shadow
// 																	transition: 'all 0.2s ease',
// 																	'&:hover': {
// 																		transform: 'translateY(-2px)',
// 																		boxShadow: '0 6px 12px rgba(0,0,0,0.3)'
// 																	}
// 																}}
// 																startIcon={<LocalShipping style={{ fontSize: '24px', color: '#fff' }} />}
// 															>
// 																{t("Delivery")}
// 															</Button>
// 														</motion.div>
// 													) : (
// 														<></>
// 													)}
// 												</>
// 											)}
// 										</div>
// 									</div>

// 									{/* Browse Menu Button */}
// 									<motion.div
// 										initial="hidden"
// 										whileInView="visible"

// 										variants={scrollVariants}
// 										style={{ display: 'flex', justifyContent: 'center' }}
// 										whileHover={{ scale: 1.02 }}
// 									>
// 										<ButtonStrap
// 											variant="outlined"
// 											onClick={() => EnterToSections()}
// 											style={{
// 												borderColor: themeSettings.textColor,
// 												color: themeSettings.textColor,
// 												padding: '10px 24px',
// 												borderRadius: '8px',
// 												fontWeight: 500,
// 												textTransform: 'none',
// 												fontSize: '14px',
// 												width: 'auto',
// 												borderWidth: '1px'
// 											}}
// 										>
// 											{t("Browse Menu")}
// 										</ButtonStrap>
// 									</motion.div>
// 								</motion.div>


// 								<motion.div
// 									initial="hidden"
// 									whileInView="visible"

// 									variants={scrollVariants}
// 									style={{ margin: '24px 0' }}

// 									animate="visible"
// 								>
// 									<Typography
// 										variant="h6"
// 										style={{
// 											color: themeSettings.textColor,
// 											fontWeight: 600,
// 											textAlign: 'center',
// 											fontSize: '30px',
// 											lineHeight: '1.5',
// 											letterSpacing: '0.02em',
// 											textTransform: 'uppercase',
// 										}}
// 									>
// 										{t("How to Order !?")}
// 									</Typography>

// 									<motion.div
// 										initial="hidden"
// 										whileInView="visible"

// 										variants={scrollVariants}
// 										animate={{ opacity: 1, height: 'auto' }}
// 										transition={{ duration: 0.3 }}
// 										style={{
// 											borderRadius: '12px',
// 											padding: '16px',
// 											marginBottom: '24px',
// 										}}
// 									>
// 										<Typography
// 											variant="h6"
// 											style={{
// 												marginBottom: '25px',
// 												fontWeight: 600,
// 												textAlign: 'center',
// 												fontSize: '22px',
// 												lineHeight: '0.5',
// 												letterSpacing: '0.02em',
// 												textTransform: 'uppercase',
// 												color: themeSettings.textColor


// 											}}
// 										>
// 											{t("It's Very Easy !")}
// 										</Typography>

// 										<Grid style={{ padding: '16px' }} container spacing={2}>
// 											{howToOrderSteps.map((step, index) => (
// 												<Grid item xs={12} sm={6} key={index}>
// 													<motion.div
// 														initial="hidden"
// 														whileInView="visible"

// 														variants={scrollVariants}
// 														whileHover={{ scale: 1.02 }}
// 														style={{
// 															backgroundColor: themeSettings.cardColor,
// 															display: 'flex',
// 															flexDirection: 'column',
// 															alignItems: 'center',
// 															padding: '12px',
// 															textAlign: 'center',
// 															border: `1px solid ${themeSettings.cardBorderColor}`,
// 															borderRadius: '8px',
// 														}}
// 													>
// 														{step.icon}
// 														<Typography
// 															variant="subtitle1"
// 															style={{
// 																color: themeSettings.textColor,
// 																fontWeight: 500,
// 																margin: '8px 0'
// 															}}
// 														>
// 															{step.title}
// 														</Typography>
// 														<Typography
// 															variant="body2"
// 															style={{
// 																color: themeSettings.textColor,
// 																opacity: 0.8
// 															}}
// 														>
// 															{step.description}
// 														</Typography>
// 													</motion.div>
// 												</Grid>
// 											))}
// 										</Grid>
// 									</motion.div>


// 								</motion.div>



// 								{/* Location Map Section */}
// 								{treeData?.data?.data?.details?.latitude && treeData?.data?.data?.details?.longitude && (
// 									<>
// 										<motion.div
// 											initial="hidden"
// 											whileInView="visible"

// 											variants={scrollVariants}
// 											style={{
// 												margin: '24px 0',
// 												borderRadius: '12px',
// 												overflow: 'hidden',
// 												boxShadow: '0 4px 8px rgba(0,0,0,0.1)',
// 												height: '200px',
// 												width: '100vw'
// 											}}

// 											animate="visible"

// 										>
// 											<MapContainer
// 												center={[venueLocation.lat, venueLocation.lng]}
// 												zoom={15}
// 												style={{ height: '100%', width: '100%' }}
// 												zoomControl={false}
// 												dragging={false}
// 												touchZoom={false}
// 												doubleClickZoom={false}
// 												scrollWheelZoom={false}
// 												boxZoom={false}
// 												keyboard={false}
// 												tap={false}



// 											>
// 												<TileLayer

// 													url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
// 													attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
// 												/>
// 												<Marker position={[venueLocation.lat, venueLocation.lng]}>
// 													<Popup>
// 														{treeData?.data?.data?.details?.venu_name}
// 													</Popup>
// 												</Marker>
// 											</MapContainer>
// 										</motion.div>

// 										<motion.div
// 											initial="hidden"
// 											whileInView="visible"

// 											variants={scrollVariants}
// 											style={{ display: 'flex', justifyContent: 'center' }}
// 											whileHover={{ scale: 1.02 }}
// 										>
// 											<ButtonStrap

// 												variant="outlined"
// 												onClick={() => handleSocialPage(
// 													[venueLocation.lat, venueLocation.lng],
// 													'map'
// 												)}
// 												style={{
// 													borderColor: themeSettings.textColor,
// 													color: themeSettings.textColor,
// 													padding: '5px 24px',
// 													borderRadius: '8px',
// 													fontWeight: 500,
// 													textTransform: 'none',
// 													fontSize: '14px',
// 													width: 'auto',
// 													borderWidth: '1px'
// 												}}
// 											>

// 												{t("Open in Maps")}
// 												{" "}
// 												<MapOutlined />
// 											</ButtonStrap>
// 										</motion.div>
// 									</>
// 								)}
// 								{treeData?.data?.data?.details?.facebook ||
// 									treeData?.data?.data?.details?.public_whatsapp ||
// 									treeData?.data?.data?.details?.instagram ||
// 									treeData?.data?.data?.details?.twitter ||
// 									treeData?.data?.data?.details?.snapchat ||
// 									treeData?.data?.data?.details?.website ||
// 									treeData?.data?.data?.details?.tiktok ? (
// 									<motion.div
// 										initial="hidden"
// 										whileInView="visible"

// 										variants={scrollVariants}
// 										style={{
// 											marginTop: '20px',
// 											padding: '10px 0',
// 											borderTop: `1px solid ${themeSettings.cardBorderColor}`
// 										}}

// 										animate="visible"
// 									>
// 										<Typography
// 											variant="h6"
// 											style={{
// 												color: themeSettings.textColor,
// 												marginBottom: '16px',
// 												fontWeight: 600,
// 												listStyle: "none"
// 											}}
// 										>
// 											{t("Follow Us")}
// 										</Typography>

// 										<div style={{
// 											display: 'flex',
// 											justifyContent: 'center',
// 											flexWrap: 'wrap',
// 											gap: '16px',
// 											listStyle: "none"
// 										}}>
// 											{treeData?.data?.data?.details?.facebook ? (
// 												<motion.li className="mx-2" whileHover={{ scale: 1.2 }}>
// 													<img
// 														onClick={() =>
// 															handleSocialPage(treeData?.data?.data?.details?.facebook, 'facebook')
// 														}
// 														src={ISDARKTHEME(
// 															getLocalStorageMenuItem("theme") ||
// 															treeData?.details?.mobile_settings?.theme,
// 															setMobileBackColor() ||
// 															treeData?.details?.mobile_settings?.colorProps?.back
// 														) ? FacebookDarkTheme : Facebook}
// 														alt="Facebook icon"
// 														className="cursor"
// 													/>
// 												</motion.li>
// 											) : <></>}
// 											{treeData?.data?.data?.details?.public_whatsapp ? (
// 												<motion.li className="mx-2" whileHover={{ scale: 1.2 }}>
// 													<img
// 														style={{ width: "22px", height: "22px" }}
// 														onClick={() =>
// 															handleSocialPage(treeData?.data?.data?.details?.public_whatsapp, 'whatsapp')
// 														}
// 														src={ISDARKTHEME(
// 															getLocalStorageMenuItem("theme") ||
// 															treeData?.details?.mobile_settings?.theme,
// 															setMobileBackColor() ||
// 															treeData?.details?.mobile_settings?.colorProps?.back
// 														) ? WhatsappDarkTheme : Whatsapp}
// 														alt="Whatsapp icon"
// 														className="cursor"
// 													/>
// 												</motion.li>
// 											) : <></>}
// 											{treeData?.data?.data?.details?.instagram ? (
// 												<motion.li className="mx-2" whileHover={{ scale: 1.2 }}>
// 													<img
// 														onClick={() =>
// 															handleSocialPage(treeData?.data?.data?.details?.instagram, 'instagram')
// 														}
// 														src={ISDARKTHEME(
// 															getLocalStorageMenuItem("theme") ||
// 															treeData?.details?.mobile_settings?.theme,
// 															setMobileBackColor() ||
// 															treeData?.details?.mobile_settings?.colorProps?.back
// 														) ? InstagramDarkTheme : Instagram}
// 														alt="Instagram icon"
// 														className="cursor"
// 													/>
// 												</motion.li>
// 											) : <></>}
// 											{treeData?.data?.data?.details?.twitter ? (
// 												<motion.li className="mx-2" whileHover={{ scale: 1.2 }}>
// 													<img
// 														onClick={() =>
// 															handleSocialPage(treeData?.data?.data?.details?.twitter, 'twitter')
// 														}
// 														src={ISDARKTHEME(
// 															getLocalStorageMenuItem("theme") ||
// 															treeData?.details?.mobile_settings?.theme,
// 															setMobileBackColor() ||
// 															treeData?.details?.mobile_settings?.colorProps?.back
// 														) ? TwitterDarkTheme : Twitter}
// 														alt="X icon"
// 														className="cursor"
// 													/>
// 												</motion.li>
// 											) : <></>}
// 											{treeData?.data?.data?.details?.snapchat && (
// 												<motion.li className="mx-2" whileHover={{ scale: 1.2 }}>
// 													<img
// 														onClick={() =>
// 															handleSocialPage(treeData?.data?.data?.details?.snapchat, 'snapchat')
// 														}
// 														src={ISDARKTHEME(
// 															getLocalStorageMenuItem("theme") ||
// 															treeData?.details?.mobile_settings?.theme,
// 															setMobileBackColor() ||
// 															treeData?.details?.mobile_settings?.colorProps?.back
// 														) ? SnapchatDarkTheme : Snapchat}
// 														alt="Snapchat icon"
// 														className="cursor"
// 													/>
// 												</motion.li>
// 											)}
// 											{treeData?.data?.data?.details?.website ? (
// 												<motion.li className="mx-2" whileHover={{ scale: 1.2 }}>
// 													<img
// 														onClick={() =>
// 															handleSocialPage(treeData?.data?.data?.details?.website, 'website')
// 														}
// 														src={ISDARKTHEME(
// 															getLocalStorageMenuItem("theme") ||
// 															treeData?.details?.mobile_settings?.theme,
// 															setMobileBackColor() ||
// 															treeData?.details?.mobile_settings?.colorProps?.back
// 														) ? GlobalDarkTheme : Global}
// 														alt="global icon"
// 														className="cursor"
// 													/>
// 												</motion.li>
// 											) : <></>}
// 											{treeData?.data?.data?.details?.tiktok ? (
// 												<motion.li className="mx-2" whileHover={{ scale: 1.2 }}>
// 													<img
// 														onClick={() =>
// 															handleSocialPage(treeData?.data?.data?.details?.tiktok, 'tiktok')
// 														}
// 														src={ISDARKTHEME(
// 															getLocalStorageMenuItem("theme") ||
// 															treeData?.details?.mobile_settings?.theme,
// 															setMobileBackColor() ||
// 															treeData?.details?.mobile_settings?.colorProps?.back
// 														) ? Tiktok_Dark : Tiktok_Light}
// 														alt="global icon"
// 														className="cursor"
// 													/>
// 												</motion.li>
// 											) : <></>}
// 										</div>
// 									</motion.div>
// 								) : <></>}



// 								{/* Opening Hours */}
// 								<motion.div
// 									initial="hidden"
// 									whileInView="visible"

// 									variants={scrollVariants}

// 									animate="visible"
// 								>
// 									<p
// 										className="text-center head-font alignByLang"
// 										style={{
// 											cursor: 'pointer',
// 											color: setMobileTextColor(),
// 											marginTop: "20px",
// 											marginBottom: "10%",
// 											display: 'flex',
// 											alignItems: 'center',
// 											justifyContent: 'center',
// 											gap: '8px'
// 										}}
// 										onClick={toggleDrawer(true)}
// 									>
// 										<Schedule style={{ fontSize: '20px' }} />
// 										{t("Opening hours")}
// 										{getLocalStorageMenuItem("lang") === "ar" || getLocalStorageMenuItem("lang") === "fr" ?
// 											<ArrowLeftOutlined /> : <ArrowRightOutlined />}
// 									</p>
// 								</motion.div>

// 								<SwipeableDrawer
// 									anchor="bottom"
// 									open={drawerOpen}
// 									onClose={toggleDrawer(false)}
// 									onOpen={toggleDrawer(true)}
// 								>
// 									<div
// 										style={{
// 											width: '100%',
// 											backgroundColor: setMobileBackColor(),
// 											position: 'relative',
// 											padding: '16px',
// 										}}
// 										role="presentation"
// 									>
// 										<div className="alignByLang" style={{ paddingLeft: "20px", paddingRight: "20px", paddingTop: "25px" }}>
// 											<Badge
// 												className={`${getLocalStorageMenuItem("theme") === "dark" ? "waiting-badge-style-dark" : ""} p-2 font-size-18 sub-font m-1`}
// 											>
// 												{getLocalStorageMenuItem("tree_data")?.details?.menu_name || treeData?.data?.data?.details?.menu_name}
// 											</Badge>
// 										</div>

// 										<CloseOutlined
// 											className="alignByLang"
// 											onClick={toggleDrawer(false)}
// 											style={getLocalStorageMenuItem("lang") === "ar" || getLocalStorageMenuItem("lang") === "fr" ? {
// 												position: 'absolute',
// 												top: 10,
// 												left: 10,
// 												cursor: 'pointer',
// 												color: setMobileTextColor()
// 											} :
// 												{
// 													position: 'absolute',
// 													top: 10,
// 													right: 10,
// 													cursor: 'pointer',
// 													color: setMobileTextColor()
// 												}}
// 										/>
// 										<MenuAvailabilityComponent availability={treeData?.data?.data?.details?.availability} />
// 									</div>
// 								</SwipeableDrawer>
// 							</motion.div>

// 							<LoginComponent
// 								open={loginDialogOpen}
// 								handleCloseDialog={handleCloseLoginDialog}
// 								tableQr={tableQr}
// 								tableName={tableName}
// 								onVerificationSuccess={handleVerificationSuccess}
// 								is_from={getLocalStorageMenuItem("pendingDelivery") === "true" ? 3 : 1}
// 							/>

// 							<Toast
// 								open={toastSettings.open}
// 								message={toastSettings.message}
// 								resetToast={handleCloseToast}
// 								success={toastSettings.success}
// 							/>
// 						</Container>
// 					</div>
// 				</div>

// 				<motion.footer
// 					initial="hidden"
// 					whileInView="visible"
// 					variants={scrollVariants}
// 					style={{
// 						backgroundColor: themeSettings.cardColor,
// 						padding: '12px 8px',
// 						borderTop: `1px solid ${themeSettings.cardBorderColor}`,
// 						marginTop: '5px'
// 					}}
// 				>
// 					<Container>
// 						{/* First Section - Logo and Venue Name */}
// 						<div style={{
// 							display: 'flex',
// 							flexDirection: 'column',
// 							alignItems: 'center',
// 							marginBottom: '24px',
// 							padding: 0
// 						}}>
// 							<img
// 								src={treeData?.data?.data?.details?.logo || no_image}
// 								alt="Venue Logo"
// 								style={{
// 									width: '80px',
// 									height: '80px',
// 									borderRadius: '50%',
// 									objectFit: 'cover',
// 									marginBottom: '16px',
// 									border: `2px solid ${themeSettings.cardBorderColor}`
// 								}}
// 								onError={onImageError}
// 							/>
// 							<Typography
// 								variant="h6"
// 								style={{
// 									color: themeSettings.textColor,
// 									fontWeight: 600,
// 									textAlign: 'center'
// 								}}
// 							>
// 								{treeData?.data?.data?.details?.venu_name}
// 							</Typography>
// 						</div>

// 						{/* Second Section - Links */}
// 						<div style={{
// 							display: 'flex',
// 							justifyContent: 'center',
// 							flexWrap: 'wrap',
// 							gap: '0px'
// 						}}>
// 							{/* Home Link */}
// 							<Button
// 								variant="text"
// 								onClick={EnterToSections}
// 								style={{
// 									color: themeSettings.textColor,
// 									textTransform: 'none'
// 								}}
// 							>
// 								{t("Home")}
// 							</Button>

// 							{/* Profile Link (if logged in) */}
// 							{getLocalStorageMenuItem("mobileLoginToken") && (
// 								<Button
// 									variant="text"
// 									onClick={() => handleClickNavigation("profile")}
// 									style={{
// 										color: themeSettings.textColor,
// 										textTransform: 'none'
// 									}}
// 								>
// 									{t("My Profile")}
// 								</Button>
// 							)}

// 							{/* Orders Link */}
// 							{allTreeData?.details?.order_ability && getLocalStorageMenuItem("mobileLoginToken") && (
// 								<Button
// 									variant="text"
// 									onClick={() => handleClickNavigation("orders")}
// 									style={{
// 										color: themeSettings.textColor,
// 										textTransform: 'none'
// 									}}
// 								>
// 									{t("My orders")}
// 								</Button>
// 							)}

// 							{/* Wallet Link */}
// 							{getLocalStorageMenuItem("mobileLoginToken") && (
// 								<Button
// 									variant="text"
// 									onClick={() => handleClickNavigation("transactions")}
// 									style={{
// 										color: themeSettings.textColor,
// 										textTransform: 'none'
// 									}}
// 								>
// 									{t("Wallet")}
// 								</Button>
// 							)}

// 							{/* Favorites Link */}
// 							<Button
// 								variant="text"
// 								onClick={() => handleClickNavigation("favorites")}
// 								style={{
// 									color: themeSettings.textColor,
// 									textTransform: 'none'
// 								}}
// 							>
// 								{t("Favorites")}
// 							</Button>

// 							{/* Feedback Link */}
// 							<Button
// 								variant="text"
// 								onClick={() => handleClickNavigation("feedback")}
// 								style={{
// 									color: themeSettings.textColor,
// 									textTransform: 'none'
// 								}}
// 							>
// 								{t("Your opinion Matters!")}
// 							</Button>

// 							{/* Privacy Policy Link */}
// 							<Button
// 								variant="text"
// 								onClick={() => handleClickNavigation("privacy")}
// 								style={{
// 									color: themeSettings.textColor,
// 									textTransform: 'none'
// 								}}
// 							>
// 								{t("Privacy Policy")}
// 							</Button>

// 							{/* Terms and Conditions Link */}
// 							<Button
// 								variant="text"
// 								onClick={() => handleClickNavigation("terms")}
// 								style={{
// 									color: themeSettings.textColor,
// 									textTransform: 'none'
// 								}}
// 							>
// 								{t("Terms and Conditions")}
// 							</Button>

// 							{/* Logout Link (if logged in) */}
// 							{getLocalStorageMenuItem("mobileLoginToken") && (
// 								<Button
// 									variant="text"
// 									onClick={() => handleClickNavigation("logout")}
// 									style={{
// 										color: themeSettings.textColor,
// 										textTransform: 'none'
// 									}}
// 								>
// 									{t("Logout")}
// 								</Button>
// 							)}
// 						</div>

// 						{/* Copyright Text */}
// 						<Typography
// 							variant="body2"
// 							style={{
// 								color: themeSettings.textColor,
// 								opacity: 0.7,
// 								textAlign: 'center',
// 								marginTop: '24px'
// 							}}
// 						>
// 							© {new Date().getFullYear()} {treeData?.data?.data?.details?.venu_name}. {t("All rights reserved")}
// 						</Typography>
// 					</Container>
// 				</motion.footer>

// 			</div>

// 			{/* Delivery Workflow Dialogs */}
// 			<DeliveryDialog
// 				open={deliveryDialogOpen}
// 				savedPlaces={savedPlaces}
// 				isLoadingSavedPlaces={loadingSavedPlaces}
// 				openLocationFormDailog={() => setOpenLocationFormDialog(true)}
// 				onClose={() => setDeliveryDialogOpen(false)}
// 				onSelect={handleOptionSelect}
// 				onSelectPlace={handleSelectPlace}
// 				openDeleteLocationDialog={handleOpenDeleteLocationDialog}
// 			/>

// 			<CurrentLocationDialog
// 				open={mode === "current"}
// 				onClose={() => setMode(null)}
// 				setLatLangVal={setLatLangVal}
// 				updateLocationFormData={updateLocationFormData}
// 				setMobileBackColor={setMobileBackColor}
// 				setMobileTextColor={setMobileTextColor}
// 				setMobileCardBorderColor={setMobileCardBorderColor}
// 			/>

// 			<NewLocationDialog
// 				open={mode === "new"}
// 				onClose={() => setMode(null)}
// 				openLocationFormDailog={() => setOpenLocationFormDialog(true)}
// 				closeLocationFormDailog={() => handleCloseFormDialog()}
// 				setLatLangVal={setLatLangVal}
// 				closeMapModal={() => setMode(null)}
// 				updateLocationFormData={(pickupMapAddress) => updateLocationFormData(pickupMapAddress)}
// 				setMobileBackColor={setMobileBackColor}
// 				setMobileTextColor={setMobileTextColor}
// 				setMobileCardBorderColor={setMobileCardBorderColor}
// 			/>

// 			<LocationFormDialog
// 				open={openLocationFormDialog}
// 				onClose={handleCloseFormDialog}
// 				isEditDelivery={isEditDelivery}
// 				isProcessLoading={isProcessLoading}
// 				locationFormData={locationFormData}
// 				handleLocationFormInputChange={(e) => {
// 					setLocationFormData(prev => ({ ...prev, [e.target.name]: e.target.value }));
// 				}}
// 				handleSaveLocation={handleSaveLocation}
// 				handleUpdateLocation={handleUpdateLocation}
// 				setMobileBackColor={setMobileBackColor}
// 				setMobileTextColor={setMobileTextColor}
// 				setMobileCardBorderColor={setMobileCardBorderColor}
// 				setMobileCardColor={setMobileCardColor}
// 				setMobileButttonBackColor={setMobileButttonBackColor}
// 			/>

// 			<DeleteLocationDialog
// 				onDeleteDeleteLocationDialog={handleDeleteLocation}
// 				deleteLocationDialogOpen={deleteLocationDialogOpen}
// 				onCloseDeleteLocationDialog={() => setDeleteLocationDialogOpen(false)}
// 			/>

// 			<Backdrop open={isProcessLoading} sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}>
// 				<CircularProgress color="inherit" />
// 			</Backdrop>


// 			<Dialog
// 				open={showInfoDailog}
// 				onClose={() => setShowInfoDailog(false)}
// 				maxWidth="sm"
// 				PaperProps={{
// 					style: {
// 						borderRadius: 15,
// 						padding: "20px",
// 						backgroundColor: dialogStyles.backgroundColor,
// 						border: `1px solid ${setMobileCardBorderColor()}'}`,
// 					},
// 				}}
// 			>
// 				<DialogTitle sx={{ textAlign: "center", paddingBottom: 0 }}>
// 					<Typography variant="h6" fontWeight="bold" color={setMobileTextColor()}>
// 						{t("Hi")}
// 					</Typography>
// 				</DialogTitle>
// 				<DialogContent>
// 					<Box sx={{ display: "flex", justifyContent: "center", padding: "10px" }}>
// 						<Typography variant="body1" textAlign="center" color={dialogStyles.color}>
// 							{t("Your order sent and it will be with you as sson as possible, Thank you.")}
// 						</Typography>
// 					</Box>
// 				</DialogContent>
// 				<DialogActions sx={{ justifyContent: "center" }}>
// 					<Button
// 						onClick={() => setShowInfoDailog(false)}
// 						sx={{
// 							backgroundColor: setMobileCardBorderColor(),
// 							color: '#fff',
// 							padding: "8px 16px",
// 							borderRadius: "30px",
// 							"&:hover": {
// 								backgroundColor: setMobileCardBorderColor(),
// 							},
// 						}}
// 					>
// 						{t("ok")}
// 					</Button>
// 				</DialogActions>
// 			</Dialog>
// 		</div>
// 	);
// };

// export default WellcomeScreen;


import { Badge, Container, Navbar, Button as ButtonStrap } from "react-bootstrap";
import axios from "axios";
import no_image from "../images/No_Image_Available.jpg";
import coverSample from "../images/No_Image_Available.jpg";
import Snapchat from "../images/snapchat.svg";
import Facebook from "../images/facebook-icon.svg";
import Twitter from "../images/twitter.svg";
import Instagram from "../images/instigram.svg";
import Global from "../images/global.svg";
import Whatsapp from "../images/whatsapp.svg";
import Map from "../images/map.svg";
import Tiktok_Light from "../images/tiktok_light.svg";
import SnapchatDarkTheme from "../images/snap-icon-dark-theme.svg";
import FacebookDarkTheme from "../images/facebook-icon-dark-theme.svg";
import TwitterDarkTheme from "../images/x-icon-dark-theme.svg";
import InstagramDarkTheme from "../images/insta-icon-dark-theme.svg";
import WhatsappDarkTheme from "../images/whatsapp-icon-dark-theme.svg";
import MapDarkTheme from "../images/map-dark-icon-theme.svg";
import GlobalDarkTheme from "../images/global-icon-dark-theme.svg";
import Tiktok_Dark from "../images/tiktok_dark.svg";
import {
	Box, Dialog, DialogContent, DialogTitle, FormControl,
	MenuItem, Select, SwipeableDrawer, Backdrop, CircularProgress,
	Typography,
	Grid,
	Button,
	AppBar,
	Toolbar,
	IconButton,
	Drawer,
	List,
	ListItem,
	ListItemIcon,
	ListItemText,
	Menu,
	DialogActions
} from "@mui/material";
import {
	AllLanguagesCode,
	generateRandomToken,
	getAndSaveTimeZone,
	getAuth,
	setMobileBackColor,
	setMobileButttonBackColor,
	setMobileCardBorderColor,
	setMobileCardColor,
	setMobileSettings,
	setMobileTextColor,
	setMobileTextField_BK_FONT_Border_StyleColor,

	FCM_TOKEN,
	fetchWalletBalance,
	getAuthMobile,
	getGustAuthMobile,
	sendNotificationFirebaseRes,
	ISDARKTHEME,
	setLocalStorageMenuItem,
	getLocalStorageMenuItem,
} from "../utility";
import { useQuery } from "react-query";
import { useLocation, useNavigate, useParams, useSearchParams } from "react-router-dom";
import Loading from "../common/loading";
import "../css/mobileScreens.css";
import i18next, { t } from "i18next";
import { useEffect, useState } from "react";
import ErrorDialog from "../common/errorDialog";
import MenuAvailabilityComponent from "../components/mobile screen/mobileComponents/MenuAvailabilityComponent";
import {
	ArrowLeftOutlined, ArrowRightOutlined, CloseOutlined,
	Person, LocationOn, Schedule, Restaurant, LocalShipping, TakeoutDining,
	ShoppingCart,
	CheckCircle,
	Payment,
	DeliveryDining,
	LocalDining,
	Home,
	RestaurantMenu,
	ContactMail,
	Share,
	ExpandMore,
	ChevronRight,
	Phone,
	Email,
	TranslateOutlined,
	MapOutlined,
	ChevronLeft
} from "@mui/icons-material";
import CheckOutlinedIcon from "@mui/icons-material/CheckOutlined";
import DarkModeIcon from "@mui/icons-material/DarkMode";
import LightModeIcon from "@mui/icons-material/LightMode";

import MenuIcon from '@mui/icons-material/Menu';
import CloseIcon from '@mui/icons-material/Close';
import LoginComponent from "../components/mobile screen/mobileComponents/loginComponent";
import { AnimatePresence, motion, useAnimation } from "framer-motion";
import { useInView } from "react-intersection-observer";
import { MapContainer, TileLayer, Marker, Popup } from 'react-leaflet';
import L from 'leaflet';
import 'leaflet/dist/leaflet.css';

// Import your existing dialog components
import DeliveryDialog from "../components/DeliveryDialog";
import CurrentLocationDialog from "../components/map screens/CurrentLocationDialog";
import NewLocationDialog from "../components/map screens/NewLocationDialog";
import LocationFormDialog from "../components/map screens/LocationFormDialog";
import DeleteLocationDialog from "../components/DeleteLocationDialog";
import Toast from "../common/toast";

// Fix for default marker icons in Leaflet
delete L.Icon.Default.prototype._getIconUrl;
L.Icon.Default.mergeOptions({
	iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png'),
	iconUrl: require('leaflet/dist/images/marker-icon.png'),
	shadowUrl: require('leaflet/dist/images/marker-shadow.png')
});



const WellcomeScreen = ({ tableQr, tableName }) => {
	const [params, setParams] = useSearchParams();
	const navigate = useNavigate();

	const [loadingTree, setLoadingTree] = useState(false);
	const [drawerOpen, setDrawerOpen] = useState(false);
	const mobileLoginToken = getLocalStorageMenuItem("mobileLoginToken") || "";
	const [loginDialogOpen, setLoginDialogOpen] = useState(false);

	const [customerBalance, setCustomerBalance] = useState(getLocalStorageMenuItem("customer_balance") || 0);
	const app_mode = getLocalStorageMenuItem("theme");

	// Order type state
	const [selectedOrderType, setSelectedOrderType] = useState(
		getLocalStorageMenuItem("orderType") || null
	);

	const [toastSettings, setToastSettings] = useState({
		open: false,
		message: "",
		success: false,
	});

	const handleOpenToast = (message, state) => {
		setToastSettings({
			open: true,
			success: state,
			message: message
		});
	};

	const handleCloseToast = (event, reason) => {
		if (reason === "clickaway") {
			return;
		}

		setToastSettings({ open: false, message: "", success: false });
	};

	// Delivery workflow state (using your existing structure)
	const [mode, setMode] = useState(null);
	const [selectedPlace, setSelectedPlace] = useState(null);
	const [placeAddress, setPlaceAddress] = useState("");
	const [latLangVal, setLatLangVal] = useState(null);
	const [isEditDelivery, setIsEditDelivery] = useState(false);
	const [isProcessLoading, setIsProcessLoading] = useState(false);
	const [deleteLocationDialogOpen, setDeleteLocationDialogOpen] = useState(false);
	const [deliveryDialogOpen, setDeliveryDialogOpen] = useState(false);
	const [openLocationFormDialog, setOpenLocationFormDialog] = useState(false);
	const [defaultAddress, setDefaultAddress] = useState(null);
	const [savedPlaces, setSavedPlaces] = useState([]);
	const [loadingSavedPlaces, setLoadingSavedPlaces] = useState(false);
	const [sideMenuOpen, setSideMenuOpen] = useState(false);



	// const location = useLocation();

	// useEffect(() => {
	// 	window.scrollTo(0, 0);
	// }, [location.pathname]);

	// useEffect(() => {
	// 	window.scrollTo({
	// 		top: 0,
	// 		behavior: 'smooth'
	// 	});
	// }, [location.pathname]);

	const toggleSideMenu = (open) => () => {
		setSideMenuOpen(open);
	};



	// Menu items data


	const initialLocationFormData = {
		title: "",
		street: "",
		unit_number: "",
		floor_number: "",
		apartment_number: "",
		description: "",
		latitude: "",
		longitude: "",
		suburb: "",
		city: "",
		province: "",
		state: "",
		postcode: "",
		country: ""
	};
	const themeSettings = {
		backColor: setMobileBackColor(),
		textColor: setMobileTextColor(),
		cardBorderColor: setMobileCardBorderColor(),
		buttonBackColor: setMobileButttonBackColor(),
		cardColor: setMobileCardColor()
	};

	const [locationFormData, setLocationFormData] = useState(initialLocationFormData);
	const [allTreeData, setAllTreeData] = useState(() => {
		const savedTreeData = getLocalStorageMenuItem("tree_data");
		return savedTreeData ? savedTreeData : [];
	});

	const controls = useAnimation();
	const [ref, inView] = useInView({
		threshold: 0.1,
		triggerOnce: false
	});



	const [slides, setSlides] = useState([
		{
			image: allTreeData?.details?.cover || no_image,
			title: allTreeData?.details?.venu_name,
		},
		{
			image: allTreeData?.details?.cover || no_image,
			title: t("Special Offers"),
		},
		// Add more slides as needed
	]);

	const [currentSlide, setCurrentSlide] = useState(0);

	useEffect(() => {
		const interval = setInterval(() => {
			setCurrentSlide((prev) => (prev === slides.length - 1 ? 0 : prev + 1));
		}, 5000); // Change slide every 5 seconds

		return () => clearInterval(interval);
	}, [slides.length]);


	useEffect(() => {
		if (inView) {
			controls.start("visible");
		} else {
			controls.start("hidden");
		}
	}, [controls, inView]);

	// Define your animation variants
	const scrollVariants = {
		hidden: {
			opacity: 0,
			y: 50,
			transition: { duration: 0.5 }
		},
		visible: {
			opacity: 1,
			y: 0,
			transition: { duration: 0.5 }
		}
	};

	const textOverlayVariants = {
		hidden: {
			opacity: 0,
			y: 20
		},
		visible: {
			opacity: 1,
			y: 0,
			transition: {
				duration: 0.8,
				ease: "easeOut"
			}
		}
	};



	const [showHowToOrder, setShowHowToOrder] = useState(true);

	const [anchorlang, setAnchorlang] = useState(null);
	const language = getLocalStorageMenuItem("lang");
	const [showInfoDailog, setShowInfoDailog] = useState(false);

	const openLang = Boolean(anchorlang);

	const howToOrderSteps = [
		{
			icon: <ShoppingCart sx={{ fontSize: 40, color: themeSettings.buttonBackColor }} />,
			title: t("Select Items"),
			description: t("Browse our menu and add items to your cart")
		},
		{
			icon: <CheckCircle sx={{ fontSize: 40, color: themeSettings.buttonBackColor }} />,
			title: t("Review Order"),
			description: t("Check your items and make any changes before checkout")
		},
		{
			icon: <Payment sx={{ fontSize: 40, color: themeSettings.buttonBackColor }} />,
			title: t("Make Payment"),
			description: t("Choose your payment method and complete your order")
		},
		{
			icon: <DeliveryDining sx={{ fontSize: 40, color: themeSettings.buttonBackColor }} />,
			title: t("Receive Order"),
			description: t("Pick up your order or get it delivered to your location")
		}
	];




	const handleOpenLoginDialog = (is_from_order) => {
		setLoginDialogOpen(true);
	};

	const handleCloseLoginDialog = () => {
		setLoginDialogOpen(false);
	};

	const handleVerificationSuccess = (token) => {
		if (token) {
			setLocalStorageMenuItem("mobileLoginToken", token || "");

			setLoginDialogOpen(false);

			if (getLocalStorageMenuItem("pendingDelivery") ) {
				setDeliveryDialogOpen(true);
				setLocalStorageMenuItem("pendingDelivery", "false");
			}
		}
	};

	const checkLoginToken = () => {
		if (mobileLoginToken && mobileLoginToken?.length > 0) {
			return true;
		}
		return false;
	}

	const toggleDrawer = (open) => () => {
		setDrawerOpen(open);
	};

	const increaseScansCount = async () => {
		try {
			const response = await axios.post(
				`${process.env.REACT_APP_API}/menus/${tableQr}/increase-scans-count`,
				getAuth()
			);
		} catch (error) {
			console.error("Error increasing ScansCount:", error);
		}
	};

	useEffect(() => {
		if (!getLocalStorageMenuItem("gustToken")) {
			setLocalStorageMenuItem("gustToken", generateRandomToken(25));
		}

		getAndSaveTimeZone();

		// Load saved places if user is logged in
		if (mobileLoginToken) {
			fetchSavedPlaces();
		}
	}, [mobileLoginToken]);

	const fetchSavedPlaces = async () => {
		setLoadingSavedPlaces(true);
		try {
			const [placesResponse, defaultResponse] = await Promise.all([
				axios.get(`${process.env.REACT_APP_API}/customer/addresses`, {
					headers: { Authorization: `Bearer ${mobileLoginToken}` }
				}),
				axios.get(`${process.env.REACT_APP_API}/customer/addresses/default`, {
					headers: { Authorization: `Bearer ${mobileLoginToken}` }
				})
			]);

			const defaultAddressId = defaultResponse.data.data?.id;
			const placesWithDefault = placesResponse.data.data.map(place => ({
				...place,
				isDefault: place.id === defaultAddressId
			}));

			setSavedPlaces(placesWithDefault);
			if (defaultResponse.data.data) {
				setDefaultAddress(defaultResponse.data.data);
			}
		} catch (error) {
			console.error("Error fetching addresses:", error);
		} finally {
			setLoadingSavedPlaces(false);
		}
	};

	const handleOrderTypeSelect = (type) => {
		setSelectedOrderType(type);
		setLocalStorageMenuItem("orderType", type);

		if (type === "delivery") {

			if (!mobileLoginToken) {
				setLoginDialogOpen(true);
				setLocalStorageMenuItem("pendingDelivery", "true");
			} else {
				setDeliveryDialogOpen(true);
			}
		} else {
			EnterToSections();
		}
	};

	const handleOptionSelect = (option) => {
		setMode(option);
	};

	const updateLocationFormData = (pickupMapAddress) => {
		setLocationFormData(prev => ({
			...prev,
			unit_number: pickupMapAddress?.house_number || "",
			street: pickupMapAddress?.road || "",
			suburb: pickupMapAddress?.suburb || pickupMapAddress?.neighbourhood || "",
			city: pickupMapAddress?.city || pickupMapAddress?.town || pickupMapAddress?.village || "",
			province: pickupMapAddress?.state || "",
			state: pickupMapAddress?.state || "",
			postcode: pickupMapAddress?.postcode || "",
			country: pickupMapAddress?.country || ""
		}));
	};



	const getDistanceAndDuration = async (start, end) => {
		try {
			const url = `https://router.project-osrm.org/route/v1/driving/${start.lng},${start.lat};${end.lng},${end.lat}?overview=false`;
			const response = await axios.get(url);
			const data = response.data;

			const distanceInMeters = data.routes[0].distance;
			const durationInSeconds = data.routes[0].duration;

			return {
				distanceInMeters,
				durationInSeconds
			};
		} catch (error) {
			console.error('Error fetching distance and duration:', error);
			return null;
		}
	};

	const handleSelectPlace = async (place, is_edit) => {
		setLocationFormData(place || {});
		setIsEditDelivery(is_edit);

		const venue_latitude = allTreeData?.details?.venue_latitude || 0;
		const venue_longitude = allTreeData?.details?.venue_longitude || 0;
		const selectedPlace_latitude = place?.latitude || 0;
		const selectedPlace_longitude = place?.longitude || 0;

		const distanceAndDuration = await getDistanceAndDuration(
			{ lat: venue_latitude, lng: venue_longitude },
			{ lat: selectedPlace_latitude, lng: selectedPlace_longitude }
		);

		if (distanceAndDuration) {
			const { distanceInMeters } = distanceAndDuration;
			const distanceInKm = (distanceInMeters / 1000).toFixed(2);
			if (distanceInKm > 20) {
				handleOpenToast(t("Selected location is too far (more than 20km). Please choose a closer location."), false);
				return;
			}
		}

		const addressParts = [
			`${t("LocationName")} ${place.title || 'NAN'}`,
			`${t("Street")} ${place.street || 'NAN'}`,
			`${t("Unit No")} ${place.unit_number || 'NAN'}`,
			`${t("Floor No")} ${place.floor_number || 'NAN'}`,
			`${t("Apartment No")} ${place.apartment_number || 'NAN'}`
		];

		setPlaceAddress(addressParts.join(", "));
		setSelectedPlace(place);
		EnterToSections();

		if (!is_edit) {
			await setDefaultAddressApi(place.id);
			resetLocationForm();
			setDeliveryDialogOpen(false);
		}
	};

	const setDefaultAddressApi = async (addressId) => {
		try {
			const response = await axios.post(
				`${process.env.REACT_APP_API}/customer/addresses/${addressId}/default`,
				{},
				{
					headers: {
						Authorization: `Bearer ${mobileLoginToken}`,
					},
				}
			);
			if (response.data.success) {
				setDefaultAddress(selectedPlace);
				// Update the saved places to reflect the new default
				fetchSavedPlaces();
			}
		} catch (error) {
			console.error("Error setting default address:", error);
		}
	};

	const handleSaveLocation = async () => {
		setIsProcessLoading(true);
		const newPlace = {
			...locationFormData,
			latitude: latLangVal?.lat + "",
			longitude: latLangVal?.lng + "",
		};

		try {
			const response = await axios.post(
				`${process.env.REACT_APP_API}/customer/addresses`,
				newPlace,
				{
					headers: {
						Authorization: `Bearer ${mobileLoginToken}`,
					},
				}
			);

			if (response.status === 200 || response.status === 201) {
				setMode(null);
				setOpenLocationFormDialog(false);
				resetLocationForm();
				fetchSavedPlaces();
			}
		} catch (error) {
			console.error("Error saving location:", error);
		} finally {
			setIsProcessLoading(false);
		}
	};

	const handleUpdateLocation = async () => {
		setIsProcessLoading(true);
		try {
			const response = await axios.post(
				`${process.env.REACT_APP_API}/customer/addresses/${locationFormData.id}`,
				locationFormData,
				{
					headers: {
						Authorization: `Bearer ${mobileLoginToken}`,
					},
				}
			);

			if (response.status === 200 || response.status === 201) {
				setMode(null);
				setOpenLocationFormDialog(false);
				resetLocationForm();
				fetchSavedPlaces();
			}
		} catch (error) {
			console.error("Error updating location:", error);
		} finally {
			setIsProcessLoading(false);
		}
	};

	const handleDeleteLocation = async () => {
		setIsProcessLoading(true);
		try {
			const response = await axios.delete(
				`${process.env.REACT_APP_API}/customer/addresses/${selectedPlace.id}`,
				{
					headers: {
						Authorization: `Bearer ${mobileLoginToken}`,
					},
				}
			);

			if (response.status === 200 || response.status === 201) {
				setMode(null);
				setDeleteLocationDialogOpen(false);
				resetLocationForm();
				fetchSavedPlaces();
			}
		} catch (error) {
			console.error("Error deleting location:", error);
		} finally {
			setIsProcessLoading(false);
		}
	};

	const resetLocationForm = () => {
		setLocationFormData(initialLocationFormData);
		setLatLangVal(null);
		setIsEditDelivery(false);
	};

	const handleCloseFormDialog = () => {
		setOpenLocationFormDialog(false);
		resetLocationForm();
	};

	const handleOpenDeleteLocationDialog = (place) => {
		setDeleteLocationDialogOpen(true);
		setSelectedPlace(place);
	};

	const handleSocialPage = (data, type) => {
		if (type === "whatsapp") {
			const phoneNumber = data.replace(/\D/g, "");
			const message = "";
			const encodedMessage = encodeURIComponent(message);
			window.open(`https://api.whatsapp.com/send?phone=${phoneNumber}&text=${encodedMessage}`, "_blank");
		} else if (type === "map") {
			const lat = data[0];
			const long = data[1];
			window.open(`https://www.google.com/maps/search/?api=1&query=${lat},${long}`, "_blank");
		} else {
			window.open(data, "_blank");
		}
	};

	const onImageError = (e) => {
		e.target.src = coverSample;
	};

	const {
		data: languageData,
		isLoading: languageisLoading,
		isError: languageIsError,
		error: languageErrroPublic,
	} = useQuery("public-languages", () => {
		try {
			return axios.get(
				`${process.env.REACT_APP_API}/menus/${tableQr}/public-languages`
			);
		} catch (error) { }
	});

	const handleDefaultLang = () => {
		const language = AllLanguagesCode.filter((lang) => {
			return navigator.language.includes(lang);
		});

		if (language?.length > 0) {
			if (params.get("lang") && params.get("lang").length > 0) {
				i18next.changeLanguage(params.get("lang"));
				document.querySelector("html").lang = params.get("lang");
				setLocalStorageMenuItem("lang", params.get("lang"));
				if (params.get("lang") === "ar" || params.get("lang") === "fa") {
					document.body.classList.add("arabic-font");
					document.body.classList.remove("latino-font");
				} else {
					document.body.classList.add("latino-font");
					document.body.classList.remove("arabic-font");
				}
				return params.get("lang");
			}
		}

		if (!getLocalStorageMenuItem("lang")) {
			const selectedLanguage = language[0];
			var checkDefaultLang = languageData?.data.data.languages?.some(language => language.code === selectedLanguage)
			if (checkDefaultLang) {
				i18next.changeLanguage(selectedLanguage);
				document.querySelector("html").lang = selectedLanguage;
				setLocalStorageMenuItem("lang", selectedLanguage);
				if (selectedLanguage === "ar" || selectedLanguage === "fa") {
					document.body.classList.add("arabic-font");
					document.body.classList.remove("latino-font");
				} else {
					document.body.classList.add("latino-font");
					document.body.classList.remove("arabic-font");
				}
				return selectedLanguage;
			} else {
				i18next.changeLanguage(languageData?.data?.data?.languages[0]?.code);
				document.querySelector("html").lang = languageData?.data?.data?.languages[0]?.code;
				setLocalStorageMenuItem("lang", languageData?.data?.data?.languages[0]?.code);

				if (languageData?.data?.data?.languages[0]?.code === "ar" || languageData?.data?.data?.languages[0]?.code === "fa") {
					document.body.classList.add("arabic-font");
					document.body.classList.remove("latino-font");
				} else {
					document.body.classList.add("latino-font");
					document.body.classList.remove("arabic-font");
				}

				return languageData?.data?.data?.languages[0]?.code;
			}

		} else {
			return getLocalStorageMenuItem("lang");
		}
	};

	const handleLanguage = (event) => {
		const lang = event.target.value;
		i18next.changeLanguage(lang);
		document.querySelector("html").lang = lang;
		setLocalStorageMenuItem("lang", lang);
		params.set("lang", lang);

		if (lang === "ar" || lang === "fa") {
			document.body.classList.add("arabic-font");
			document.body.classList.remove("latino-font");
		} else {
			document.body.classList.add("latino-font");
			document.body.classList.remove("arabic-font");
		}
		setParams(params);
	};

	const handleClickLang = (event) => {
		setAnchorlang(event.currentTarget);
	};

	const handleCloseLang = () => {
		setAnchorlang(null);
	};

	const handleLanguagedata = async (langCode) => {
		setLoadingTree(true);
		try {
			const timeZone = getLocalStorageMenuItem("timezone") || "";
			const promise = await axios.get(
				`${process.env.REACT_APP_API}/menus/${tableQr}/public-tree`,
				{
					headers: {
						localization: langCode,
						timeZone: timeZone.replace(/["]+/g, ""),
					},
				}
			);
			await setLocalStorageMenuItem(
				"tree_data",
				JSON.stringify(promise?.data?.data ? promise?.data?.data : [])
			);
			i18next.changeLanguage(langCode);
			document.querySelector("html").lang = langCode;
			setLocalStorageMenuItem("lang", langCode);
			params.set("lang", langCode);
			setParams(params);

			if (langCode === "ar" || langCode === "fa") {
				document.body.classList.add("arabic-font");
				document.body.classList.remove("latino-font");
			} else {
				document.body.classList.add("latino-font");
				document.body.classList.remove("arabic-font");
			}
		} catch (error) {
		} finally {
			setLoadingTree(false);
		}
	};

	const {
		data: treeData,
		isLoading: treeDataIsLoading,
		isFetching: treeDataIsFetching,
		isError: treeDataIsError,
		error: treeDataError,
		refetch,
	} = useQuery("treeData", async () => {
		try {
			const language = AllLanguagesCode.filter((lang) => {
				return navigator.language.includes(lang);
			});
			var requestLang = "";

			const langData = await axios.get(
				`${process.env.REACT_APP_API}/menus/${tableQr}/public-languages`
			);

			if (!getLocalStorageMenuItem("lang")) {
				const selectedLanguage = language[0];
				var checkDefaultLang = langData?.data.data.languages?.some(language => language.code === selectedLanguage)
				if (checkDefaultLang) {
					requestLang = selectedLanguage;
				} else {
					requestLang = langData?.data?.data?.languages[0]?.code;
				}

			} else {
				requestLang = getLocalStorageMenuItem("lang");
			}

			const timeZone = getLocalStorageMenuItem("timezone") ? getLocalStorageMenuItem("timezone") : "";
			const promise = await axios.get(
				`${process.env.REACT_APP_API}/menus/${tableQr}/public-tree`,
				{
					headers: {
						localization: requestLang || getLocalStorageMenuItem("lang"),
						timeZone: timeZone.replace(/["]+/g, '')
					}
				}
			);
			if (promise.status === 200) {
				setLocalStorageMenuItem(
					"tree_data", JSON.stringify(promise?.data?.data ? promise?.data?.data : [])
				);
				setMobileSettings(promise?.data?.data?.details)
			}
			return promise;
		} catch (error) { }
	});

	if (treeDataError || languageIsError) {
		return <ErrorDialog />;
	}

	if (languageisLoading || treeDataIsLoading || loadingTree) {
		return <Loading backColor={setMobileBackColor()} />;
	}

	const EnterToSections = () => {
		navigate(
			`/${tableName}/${tableQr}/sections?section=0&t=${params.get(
				"t"
			)}&lang=${getLocalStorageMenuItem("lang")}`
		);
		increaseScansCount();
	}

	const navigateToPhoneNumberVerification = () => {
		navigate(`/${tableName}/${tableQr}/verify-phone?t=${params.get(
			"t"
		)}&lang=${getLocalStorageMenuItem("lang")}`);
	};

	// Animation variants
	const fadeIn = {
		hidden: { opacity: 0 },
		visible: { opacity: 1, transition: { duration: 0.8 } }
	};

	const slideUp = {
		hidden: { y: 50, opacity: 0 },
		visible: { y: 0, opacity: 1, transition: { duration: 0.6 } }
	};

	const venueLocation = {
		lat: parseFloat(treeData?.data?.data?.details?.venue_latitude) || 0,
		lng: parseFloat(treeData?.data?.data?.details?.venue_longitude) || 0
	};

	const menuItems = [

		{
			text: t('Browse Menu'),
			icon: <RestaurantMenu />,
			action: EnterToSections
		},
		{
			text: t('Opening hours'),
			icon: <Schedule />,
			action: () => {
				setSideMenuOpen(false);
				setDrawerOpen(true);
			}
		},
		{
			text: t('Contact Us'),
			icon: <ContactMail />,
			action: () => window.location.href = `tel:${treeData?.data?.data?.details?.whatsapp}`
		},
		{
			text: t('Follow Us'),
			icon: <Share />,
			action: null, // This will be handled in sub-items
			subItems: [
				treeData?.data?.data?.details?.facebook && {
					text: t('Facebook'),
					icon: <img
						src={getLocalStorageMenuItem("theme") !== "light" ? FacebookDarkTheme : Facebook}
						alt="Facebook"
						style={{ width: 24, height: 24 }}
					/>,
					action: () => handleSocialPage(treeData?.data?.data?.details?.facebook, 'facebook')
				},
				treeData?.data?.data?.details?.instagram && {
					text: t('Instagram'),
					icon: <img
						src={getLocalStorageMenuItem("theme") !== "light" ? InstagramDarkTheme : Instagram}
						alt="Instagram"
						style={{ width: 24, height: 24 }}
					/>,
					action: () => handleSocialPage(treeData?.data?.data?.details?.instagram, 'instagram')
				},
				treeData?.data?.data?.details?.twitter && {
					text: t('Twitter'),
					icon: <img
						src={getLocalStorageMenuItem("theme") !== "light" ? TwitterDarkTheme : Twitter}
						alt="Twitter"
						style={{ width: 24, height: 24 }}
					/>,
					action: () => handleSocialPage(treeData?.data?.data?.details?.twitter, 'twitter')
				},
				treeData?.data?.data?.details?.snapchat && {
					text: 'Snapchat',
					icon: <img
						src={getLocalStorageMenuItem("theme") !== "light" ? SnapchatDarkTheme : Snapchat}
						alt="Snapchat"
						style={{ width: 24, height: 24 }}
					/>,
					action: () => handleSocialPage(treeData?.data?.data?.details?.snapchat, 'snapchat')
				},
				treeData?.data?.data?.details?.public_whatsapp && {
					text: t('WhatsApp'),
					icon: <img
						src={getLocalStorageMenuItem("theme") !== "light" ? WhatsappDarkTheme : Whatsapp}
						alt="WhatsApp"
						style={{ width: 24, height: 24 }}
					/>,
					action: () => handleSocialPage(treeData?.data?.data?.details?.public_whatsapp, 'whatsapp')
				},
				treeData?.data?.data?.details?.tiktok && {
					text: t('TikTok'),
					icon: <img
						src={getLocalStorageMenuItem("theme") !== "light" ? Tiktok_Dark : Tiktok_Light}
						alt="TikTok"
						style={{ width: 24, height: 24 }}
					/>,
					action: () => handleSocialPage(treeData?.data?.data?.details?.tiktok, 'tiktok')
				},
				treeData?.data?.data?.details?.website && {
					text: t('Website'),
					icon: <img
						src={getLocalStorageMenuItem("theme") !== "light" ? GlobalDarkTheme : Global}
						alt="Website"
						style={{ width: 24, height: 24 }}
					/>,
					action: () => handleSocialPage(treeData?.data?.data?.details?.website, 'website')
				},
				(treeData?.data?.data?.details?.latitude && treeData?.data?.data?.details?.longitude) && {
					text: t('Location'),
					icon: <img
						src={getLocalStorageMenuItem("theme") !== "light" ? MapDarkTheme : Map}
						alt="Location"
						style={{ width: 24, height: 24 }}
					/>,
					action: () => handleSocialPage(
						[treeData?.data?.data?.details?.latitude, treeData?.data?.data?.details?.longitude],
						'map'
					)
				},
				treeData?.data?.data?.details?.phone && {
					text: t('Call Us'),
					icon: <Phone style={{ color: setMobileTextColor(), width: 24, height: 24 }} />,
					action: () => window.location.href = `tel:${treeData?.data?.data?.details?.phone}`
				},
				treeData?.data?.data?.details?.email && {
					text: t('Email Us'),
					icon: <Email style={{ color: setMobileTextColor(), width: 24, height: 24 }} />,
					action: () => window.location.href = `mailto:${treeData?.data?.data?.details?.email}`
				}
			].filter(Boolean)
		}
	];

	const handleClickNavigation = async (dist) => {
		const language = getLocalStorageMenuItem("lang");
		if (dist == "profile") {
			const baseUrl = `/${tableName}/${tableQr}/profile?lang=${language}`;
			const tableParam = params.get("t");
			navigate(tableParam ? `${baseUrl}&t=${tableParam}` : baseUrl);
		} else if (dist === "orders") {
			navigate(
				`/${tableName}/${tableQr}/orders?section=0&t=${params.get(
					"t"
				)}&lang=${language}`
			);
		} else if (dist === "transactions") {
			navigate(
				`/${tableName}/${tableQr}/transactions?section=0&t=${params.get(
					"t"
				)}&lang=${language}`
			);
		} else if (dist === "favorites") {
			navigate(
				`/${tableName}/${tableQr}/favorites?section=0&t=${params.get("t")}`
			);
		} else if (dist === "feedback") {
			navigate(
				`/${tableName}/${tableQr}/feedback?section=0&t=${params.get("t")}`
			);
		} else if (dist === "privacy") {
			navigate(`/${tableName}/${tableQr}/privacy-policy`);
		} else if (dist === "terms") {
			navigate(`/${tableName}/${tableQr}/terms-and-conditions`);
		} else if (dist === "logout") {
			await setLocalStorageMenuItem("mobileLoginToken", "");
			const baseUrl = `/${tableName}/${tableQr}/menus?lang=${language}`;
			const tableParam = params.get("t");
			navigate(tableParam ? `${baseUrl}&t=${tableParam}` : baseUrl);
		}
	}

	const hanldeMode = () => {
		if (getLocalStorageMenuItem("theme") === "dark") {
			setLocalStorageMenuItem("theme", "light");
			params.set("theme", "light");
			setParams(params);
		} else {
			setLocalStorageMenuItem("theme", "dark");
			params.set("theme", "dark");
			setParams(params);
		}
	};


	const handleSendNotification = async (title, body) => {
		setIsProcessLoading(true);
		try {
			const sendNotificationRes = await axios.post(
				`${process.env.REACT_APP_API}/general-notification`,
				{
					venue_id: treeData?.data?.data?.details?.venue_id,
					title: title || "",
					message: body || "",
					table: params.get("t") || "",
				}
			);

			const sendNotificationFirebase = await sendNotificationFirebaseRes(
				treeData?.data?.data?.details,
				title || "",
				body || "",
				"notifications"
			);

			if (
				sendNotificationRes?.data?.success &&
				sendNotificationFirebase?.data?.success
			) {
				setIsProcessLoading(false);

				// handleOpenToast(
				//   <div className="alignByLang">
				//     {t("Your notification sent successfully")}
				//   </div>
				//   , true);

				setShowInfoDailog(true);
			} else {
				setIsProcessLoading(false);

				handleOpenToast(
					<div className="alignByLang">
						{t("Error while sending the notification.")}
					</div>
					, false);
			}
		} catch (error) {
			setIsProcessLoading(false);

			handleOpenToast(
				<div className="alignByLang">
					{t("Error while sending the notification.") + " " + error.message}
				</div>
				, false);
		}
	};

	const dialogStyles = {
		backgroundColor: setMobileTextField_BK_FONT_Border_StyleColor()[0],
		color: setMobileTextField_BK_FONT_Border_StyleColor()[1],
		borderColor: setMobileTextField_BK_FONT_Border_StyleColor()[2],
	};

	return (
		<div
			className={`min-vh-100`}
			style={{
				backgroundColor:
					getLocalStorageMenuItem("theme") === "dark" ||
						getLocalStorageMenuItem("theme") === "costomize"
						? setMobileBackColor()
						: "",
				backgroundImage:
					getLocalStorageMenuItem("theme") === "dark" ||
						getLocalStorageMenuItem("theme") === "costomize"
						? setMobileBackColor()
						: "",
			}}
		>

			<AppBar className="alignByLang" position="sticky" elevation={0} sx={{
				backgroundColor:
					getLocalStorageMenuItem("theme") === "dark" ||
						getLocalStorageMenuItem("theme") === "costomize"
						? setMobileBackColor()
						: "",

				boxShadow: 'none',
				padding: '8px 16px',
				position: 'sticky',
				top: 0,
				left: 0,
				right: 0,
				zIndex: 1000
			}}>
				<Toolbar sx={{ justifyContent: 'space-between', padding: '0 !important' }}>
					{/* Hamburger Menu Icon */}
					<IconButton
						edge="end"
						color="inherit"
						aria-label="menu"
						onClick={toggleSideMenu(true)}
						sx={{
							color: setMobileTextColor(),
							backgroundColor: 'rgba(255, 255, 255, 0.1)',
							borderRadius: '8px',
							padding: '8px',
							'&:hover': {
								backgroundColor: 'rgba(255, 255, 255, 0.2)'
							}
						}}
					>
						<MenuIcon />
					</IconButton>

					<motion.div>
						{getLocalStorageMenuItem("mobileLoginToken") && (
							<div className="mt-2 text-center" style={{ color: setMobileTextColor() }}>
								<div className="sub-font alignByLang text-center">
									{t("Welcome")} {getLocalStorageMenuItem("customer_name")}
								</div>
							</div>
						)}
					</motion.div>

					{/* Logo */}
					<motion.div whileHover={{ scale: 1.05 }}>
						<img
							src={treeData?.data?.data?.details?.logo || no_image}
							style={{ height: '40px', maxWidth: '150px', objectFit: 'contain', borderRadius: '20px' }}
							onError={onImageError}
							alt="Venue Logo"
						/>
					</motion.div>

				</Toolbar>
			</AppBar>

			<Drawer
				anchor={getLocalStorageMenuItem("lang") === "ar" ? "right" : "left"}
				open={sideMenuOpen}
				onClose={toggleSideMenu(false)}
				sx={{
					'& .MuiDrawer-paper': {
						width: 350,
						backgroundColor: setMobileBackColor(),
						color: setMobileTextColor(),
					}
				}}
				className="alignByLang"
			>

				<div
					className={`mobile-side-bar min-vh-100`}
					style={{
						color: setMobileTextColor(),
						backgroundColor: setMobileCardColor(),
					}}
				>
					<div className="d-flex justify-content-between mobile-side-bar-top-settings p-4 sub-font">
						{/* <img
							  src={treeData?.data?.data?.details?.logo || noImageAvailable}
							  alt="logo"
							  style={{ border: `4px solid ${setMobileCardColor()} ` }}
							  className="mobile-side-bar-logo"
							  onError={onImageError}
							/> */}

						<div>
							<img
								src={treeData?.data?.data?.details?.logo || no_image}
								alt="logo"
								style={{ border: `4px solid ${setMobileCardColor()} ` }}
								className="mobile-side-bar-logo"
								onError={onImageError}
							/>
							{/* Add name and balance from localStorage */}

							{getLocalStorageMenuItem("mobileLoginToken") && (
								<div className="mt-2 text-center" style={{ color: setMobileTextColor() }}>
									<div className="sub-font alignByLang text-center">
										{t("Welcome")} {getLocalStorageMenuItem("customer_name")}
									</div>
									<div className="sub-font alignByLang text-center">
										{t("Your Balance")} : {customerBalance}
									</div>
								</div>
							)}
						</div>


						<div className="d-flex justify-content-between">
							<div>
								<span
									className="mx-2 pt-0 cursor"
									onClick={toggleSideMenu(false)}
								>
									<CloseOutlined style={{ color: setMobileTextColor() }} />
								</span>
								<span className="mx-2 pt-0 cursor" onClick={handleClickLang}>
									<TranslateOutlined style={{ color: setMobileTextColor() }} />
								</span>
								<Menu
									id="long-menu"
									MenuListProps={{
										"aria-labelledby": "long-button",
									}}
									anchorEl={anchorlang}
									open={openLang}
									onClose={handleCloseLang}
									onClick={handleCloseLang}
									PaperProps={{
										style: {
											maxHeight: 48 * 4.5,
											width: "25ch",
											backgroundColor: setMobileBackColor(),
										},
									}}
								>
									{languageData?.data?.data?.languages?.map((lang) => (
										<MenuItem
											key={lang.code}
											onClick={() => handleLanguagedata(lang?.code || "en")}
										>
											<li
												className="d-flex justify-content-between align-items-center p-1 sub-font"
												style={{
													color:
														language === lang.code
															? setMobileButttonBackColor()
															: setMobileTextColor(),
												}}
											>
												<span style={{ maxWidth: "80%" }}>
													{` ${lang.label} ( ${lang.label} ) `}
												</span>
												<span
													style={{ maxWidth: "10%" }}
													className={`${language === lang.code ? "d-block" : "d-none"
														}`}
												>
													<CheckOutlinedIcon />
												</span>
											</li>
										</MenuItem>
									))}
								</Menu>
							</div>
							<div>
								{getLocalStorageMenuItem("theme") !== "costomize" && (
									<span className="ms-2 pt-0 cursor" onClick={hanldeMode}>
										{app_mode === "dark" ? (
											<DarkModeIcon className="mode-icon-dark" />
										) : (
											<LightModeIcon className="mode-icon-light" />
										)}
									</span>
								)}
							</div>
						</div>
					</div>

					{loadingTree && <Loading backColor={setMobileBackColor()} />}

					<div className="p-24">
						<div
							className="rounded-4 m-top-12 pt-3 pb-3 px-3 alignByLang"
							style={{
								backgroundColor: setMobileBackColor(),
								borderColor: setMobileCardBorderColor(),
								borderWidth: 1,
								borderStyle: "solid",
							}}
						>
							{JSON.parse(params.get("t")) && (
								<>
									<Badge
										onClick={() =>
											handleSendNotification(
												"call waiter",
												"please call waiter for this table"

											)
										}
										style={{
											borderRadius: "8px",
										}}
										className={`outofinstock-badge-dish-style font-size-14 sub-font m-1`}
									>
										{t("Call Waiter")}
									</Badge>

									{treeData?.data?.data?.details?.notification_buttons_settings
										?.notification_1_active && (
											<Badge
												onClick={() =>
													handleSendNotification(
														treeData?.data?.data?.details?.notification_buttons_settings
															?.notification_1_title,
														treeData?.data?.data?.details?.notification_buttons_settings
															?.notification_1_body
													)
												}
												style={{
													borderRadius: "8px",
												}}
												className={`outofinstock-badge-dish-style font-size-14 sub-font m-1`}
											>
												{t(
													treeData?.data?.data?.details?.notification_buttons_settings
														?.notification_1_button
												) || ""}
											</Badge>
										)}

									{treeData?.data?.data?.details?.notification_buttons_settings
										?.notification_2_active && (
											<Badge
												onClick={() =>
													handleSendNotification(
														treeData?.data?.data?.details?.notification_buttons_settings
															?.notification_2_title,
														treeData?.data?.data?.details?.notification_buttons_settings
															?.notification_2_body
													)
												}
												style={{
													borderRadius: "8px",
												}}
												className={`outofinstock-badge-dish-style font-size-14 sub-font m-1`}
											>
												{t(
													treeData?.data?.data?.details?.notification_buttons_settings
														?.notification_2_button
												) || ""}
											</Badge>
										)}
								</>
							)}



							{getLocalStorageMenuItem("mobileLoginToken") &&
								getLocalStorageMenuItem("mobileLoginToken")?.length > 0 ? (
								<p className="m-top-12 cursor head-font" onClick={() => handleClickNavigation("profile")}>
									{t("My Profile")}
								</p>
							) : (
								""
							)}

							{allTreeData?.details?.order_ability && getLocalStorageMenuItem("mobileLoginToken") ? (
								<p onClick={() => handleClickNavigation("orders")} className="cursor head-font">
									{t("My orders")}
								</p>
							) : (
								""
							)}

							{getLocalStorageMenuItem("mobileLoginToken") &&
								getLocalStorageMenuItem("mobileLoginToken")?.length > 0 ? (
								<p className="m-top-12 cursor head-font" onClick={() => handleClickNavigation("transactions")}>
									{t("Wallet")}
								</p>
							) : (
								""
							)}

							<p className="m-top-12 cursor head-font" onClick={() => handleClickNavigation("favorites")}>
								{t("Favorites")}
							</p>

							<p onClick={() => handleClickNavigation("feedback")} className="cursor head-font">
								{t("Your opinion Matters!")}
							</p>

							<p onClick={() => handleClickNavigation("privacy")} className="cursor head-font">
								{t("Privacy Policy")}
							</p>

							<p onClick={() => handleClickNavigation("terms")} className="cursor head-font">
								{t("Terms and Conditions")}
							</p>

							{getLocalStorageMenuItem("mobileLoginToken") &&
								getLocalStorageMenuItem("mobileLoginToken")?.length > 0 ? (
								<p onClick={() => handleClickNavigation("logout")} className="cursor head-font">
									{t("Logout")}
								</p>
							) : (
								""
							)}
						</div>
					</div>
					<div style={{ borderBottom: "1px solid #aaa" }}></div>
				</div>

				<ul className="position-absolute mb-4 bottom-0 start-0 w-100 d-flex justify-content-center list-unstyled">
					{treeData?.data?.data?.details?.facebook && (
						<li className="mx-2">
							<img
								onClick={() => handleSocialPage(treeData?.data?.data?.details?.facebook)}
								src={Facebook}
								alt="Facebook icon"
								className="cursor"
							/>
						</li>
					)}
					{treeData?.data?.data?.details?.instagram && (
						<li className="mx-2">
							<img
								onClick={() => handleSocialPage(treeData?.data?.data?.details?.instagram)}
								src={Instagram}
								alt="Instagram icon"
								className="cursor"
							/>
						</li>
					)}
					{treeData?.data?.data?.details?.twitter && (
						<li className="mx-2">
							<img
								onClick={() => handleSocialPage(treeData?.data?.data?.details?.twitter)}
								src={Twitter}
								alt="X icon"
								className="cursor"
							/>
						</li>
					)}
					{treeData?.data?.data?.details?.snapchat && (
						<li className="mx-2">
							<img
								onClick={() => handleSocialPage(treeData?.data?.data?.details?.snapchat)}
								src={Snapchat}
								alt="Snapchat icon"
								className="cursor"
							/>
						</li>
					)}
					{treeData?.data?.data?.details?.website && (
						<li className="mx-2">
							<img
								onClick={() => handleSocialPage(treeData?.data?.data?.details?.website)}
								src={Global}
								alt="global icon"
								className="cursor"
							/>
						</li>
					)}
				</ul>

			</Drawer>

			<div className="row p-0 m-0">
				<div className="col-lg-8 d-none d-lg-block">
					<div className="mt-5 text-center d-flex-justify-content-center align-items-center">
						<div style={{ marginTop: "15%", left: "25%", position: "fixed" }}>
							<motion.img
								src={treeData?.data?.data?.details?.logo || no_image}
								className="me-4 slider-mobile-logo"
								style={{ width: "250px", height: "250px" }}
								onError={onImageError}

								animate="visible"
								initial="hidden"
								whileInView="visible"

								variants={scrollVariants}
							/>
							<motion.h1
								className="mt-4 head-font"
								style={{ color: setMobileTextColor() }}

								animate="visible"
								initial="hidden"
								whileInView="visible"

								variants={scrollVariants}
							>
								{treeData?.data?.data?.details?.venu_name}
							</motion.h1>
						</div>
					</div>
				</div>
				<div className="col-lg-4 ms-auto p-0">
					<motion.div
						initial="hidden"
						whileInView="visible"

						variants={scrollVariants}
						className="text-center"

						animate="visible"

						style={{
							borderBottomLeftRadius: '20px',
							borderBottomRightRadius: '20px'
						}}
					>

						<div className="slider-mobile" style={{
							position: 'relative',
							borderBottomLeftRadius: '20px',
							borderBottomRightRadius: '20px'
						}}>
							{/* Slides */}
							<AnimatePresence mode='wait'>
								<motion.div
									key={currentSlide}
									initial={{ opacity: 0 }}
									animate={{ opacity: 1 }}
									exit={{ opacity: 0 }}
									transition={{ duration: 0.5 }}
									style={{
										position: 'absolute',
										width: '100%',
										height: '100%',
										borderBottomLeftRadius: '20px',  // Added
										borderBottomRightRadius: '20px'  // Added
									}}
								>
									<img
										src={slides[currentSlide].image}
										onError={onImageError}
										style={{
											width: '100%',
											height: '100%',
											objectFit: 'cover',
											borderBottomLeftRadius: '20px',  // Added
											borderBottomRightRadius: '20px'  // Added

										}}
										alt="Slide"
									/>

									{/* Text Overlay */}
									<div style={{
										position: 'absolute',
										bottom: 0,
										left: 0,
										right: 0,
										padding: '20px',
										background: 'linear-gradient(transparent, rgba(0,0,0,0.7))',
										borderBottomLeftRadius: '20px',  // Added
										borderBottomRightRadius: '20px'  // Added
									}}>

										<motion.h3

											initial="hidden"
											whileInView="visible"
											variants={scrollVariants}
											whileHover={{ scale: 1.1 }}
											animate={{ y: 0, opacity: 1 }}
											transition={{ delay: 0.2, duration: 0.5 }}
											style={{
												color: 'white',
												marginBottom: '35px',
												fontSize: '2rem'
											}}
										>
											{slides[currentSlide].title}
										</motion.h3>
										<motion.p
											initial={{ y: 20, opacity: 0 }}
											animate={{ y: 0, opacity: 1 }}
											transition={{ delay: 0.3, duration: 0.5 }}
											style={{
												color: 'rgba(255,255,255,0.9)',
												fontSize: '1rem'
											}}
										>
											{slides[currentSlide].subtitle}
										</motion.p>
									</div>
								</motion.div>
							</AnimatePresence>

							{/* Navigation Dots */}
							<div style={{
								position: 'absolute',
								bottom: '10px',
								left: '50%',
								transform: 'translateX(-50%)',
								display: 'flex',
								gap: '8px',
								zIndex: 2
							}}>
								{slides.map((_, index) => (
									<button
										key={index}
										onClick={() => setCurrentSlide(index)}
										style={{
											width: '10px',
											height: '10px',
											borderRadius: '50%',
											border: 'none',
											background: currentSlide === index ? 'white' : 'rgba(255,255,255,0.5)',
											cursor: 'pointer',
											padding: 0
										}}
									/>
								))}
							</div>

							{/* Navigation Arrows */}
							<button
								onClick={() => setCurrentSlide(prev => (prev === 0 ? slides.length - 1 : prev - 1))}
								style={{
									position: 'absolute',
									left: '10px',
									top: '50%',
									transform: 'translateY(-50%)',
									background: 'rgba(0,0,0,0.3)',
									border: 'none',
									borderRadius: '50%',
									width: '40px',
									height: '40px',
									display: 'flex',
									alignItems: 'center',
									justifyContent: 'center',
									cursor: 'pointer',
									zIndex: 2,
									color: 'white'
								}}
							>
								<ChevronLeft />
							</button>

							<button
								onClick={() => setCurrentSlide(prev => (prev === slides.length - 1 ? 0 : prev + 1))}
								style={{
									position: 'absolute',
									right: '10px',
									top: '50%',
									transform: 'translateY(-50%)',
									background: 'rgba(0,0,0,0.3)',
									border: 'none',
									borderRadius: '50%',
									width: '40px',
									height: '40px',
									display: 'flex',
									alignItems: 'center',
									justifyContent: 'center',
									cursor: 'pointer',
									zIndex: 2,
									color: 'white'
								}}
							>
								<ChevronRight />
							</button>

							{(treeData?.data?.data?.details?.is_available && !checkLoginToken()) && (
								<motion.div
									initial="hidden"
									whileInView="visible"
									variants={scrollVariants}
									whileHover={{ scale: 1.1 }}
									style={{
										position: 'absolute',
										bottom: '20px',
										[getLocalStorageMenuItem("lang") === "ar" ? 'right' : 'left']: '20px',
										zIndex: 10
									}}
								>
									<Button
										variant="outlined"
										disabled={!treeData?.data?.data?.details?.is_available || checkLoginToken()}
										className="m-top-12 head-font"
										onClick={() => handleOpenLoginDialog()}
										style={{
											color: setMobileTextColor(),
											backgroundColor: 'rgba(0, 0, 0, 0.5)',
											borderColor: setMobileTextColor(),
											borderRadius: '50%',
											width: '50px',
											height: '50px',
											minWidth: 'unset',
											padding: 0
										}}
									>
										<Person style={{ color: setMobileTextColor() }} />
									</Button>
								</motion.div>
							)}
						</div>

					</motion.div>


					<div className="wellcomeScreen" style={{ marginTop: 10 }} >
						<Container style={{ padding: 0 }}>
							<motion.div
								initial="hidden"
								whileInView="visible"

								variants={scrollVariants}
								className="text-center"
								// style={{ paddingLeft: "24px", paddingRight: "24px" }}

								animate="visible"
							>
								<h1
									className="mb-2 head-font"
									style={{ color: setMobileTextColor() }}
								>
									{getLocalStorageMenuItem("tree_data")?.details?.venu_name || treeData?.data?.data?.details?.venu_name}
								</h1>
								<p className="head-font" style={{ color: setMobileTextColor() }}>
									{getLocalStorageMenuItem("tree_data")?.details?.description || treeData?.data?.data?.details?.description}
								</p>


								{/* Order Type Buttons with Enhanced UI */}
								<motion.div
									initial="hidden"
									whileInView="visible"

									variants={scrollVariants}
									style={{ margin: '16px 0' }}

									animate="visible"
								>
									<div style={{
										borderRadius: '12px',
										padding: '16px',
										marginBottom: '24px',
										marginLeft: '24px',
										marginRight: '24px',
										backgroundColor: themeSettings.cardColor,
										border: `1px solid ${themeSettings.cardBorderColor}`,
										boxShadow: `0 4px 12px ${themeSettings.cardBorderColor}40`,
										transition: 'all 0.3s ease',
										'&:hover': {
											boxShadow: `0 8px 24px ${themeSettings.cardBorderColor}60`
										}
									}}>
										<motion.div
											initial="hidden"
											whileInView="visible"

											variants={scrollVariants} whileHover={{ scale: 1.05 }}>
											<Restaurant style={{
												fontSize: '20px',
												color: themeSettings.cardBorderColor,
												marginBottom: 2
											}} />
											<Typography
												variant="subtitle1"
												style={{
													color: themeSettings.textColor,
													marginBottom: '16px',
													fontWeight: 600 // Made the title slightly bolder
												}}
											>
												{t("Select Order Type")}
											</Typography>
										</motion.div>

										<div style={{
											display: 'flex',
											flexDirection: 'row',
											alignItems: 'center',
											justifyContent: 'center',
											gap: '8px',
											marginBottom: '12px',
											flexWrap: 'wrap',
										}}>
											{treeData?.data?.data?.details?.is_dinein_active && params.get("t") && params.get("t") !== "null" ? (
												<>
													<motion.div
														initial="hidden"
														whileInView="visible"

														variants={scrollVariants} whileHover={{ scale: 1.05 }}>
														<Button
															variant="contained"
															onClick={() => handleOrderTypeSelect("dinein")}
															style={{
																backgroundColor: themeSettings.buttonBackColor,
																color: '#fff',
																borderRadius: '8px',
																fontWeight: 600,
																textTransform: 'none',
																fontSize: '14px',
																width: '110px',
																padding: '8px 8px',
																boxShadow: '0 4px 8px rgba(0,0,0,0.2)', // Enhanced button shadow
																transition: 'all 0.2s ease',
																'&:hover': {
																	transform: 'translateY(-2px)',
																	boxShadow: '0 6px 12px rgba(0,0,0,0.3)'
																}
															}}
															startIcon={<Restaurant style={{ fontSize: '24px' }} />}
														>
															{t("Dine In")}
														</Button>
													</motion.div>

												</>
											) : (
												<>
													{treeData?.data?.data?.details?.is_pickup_active ? (
														<>
															<motion.div
																initial="hidden"
																whileInView="visible"

																variants={scrollVariants} whileHover={{ scale: 1.05 }}>
																<Button
																	variant="contained"
																	onClick={() => handleOrderTypeSelect("pickup")}
																	style={{
																		backgroundColor: themeSettings.buttonBackColor,
																		color: '#fff',
																		borderRadius: '8px',
																		fontWeight: 600,
																		textTransform: 'none',
																		fontSize: '14px',
																		width: '110px',
																		padding: '8px 8px',
																		boxShadow: '0 4px 8px rgba(0,0,0,0.2)', // Enhanced button shadow
																		transition: 'all 0.2s ease',
																		'&:hover': {
																			transform: 'translateY(-2px)',
																			boxShadow: '0 6px 12px rgba(0,0,0,0.3)'
																		}
																	}}
																	startIcon={<LocalDining style={{ fontSize: '24px' }} />}
																>
																	{t("Pickup")}
																</Button>
															</motion.div>

														</>
													) : (
														<></>
													)}

													{treeData?.data?.data?.details?.is_delivery_active ? (
														<motion.div
															initial="hidden"
															whileInView="visible"

															variants={scrollVariants} whileHover={{ scale: 1.05 }}>
															<Button

																variant="contained"
																onClick={() => handleOrderTypeSelect("delivery")}
																style={{
																	backgroundColor: themeSettings.buttonBackColor,
																	color: '#fff',
																	borderRadius: '8px',
																	fontWeight: 600,
																	textTransform: 'none',
																	fontSize: '14px',
																	width: '110px',

																	padding: '8px 8px',
																	boxShadow: '0 4px 8px rgba(0,0,0,0.2)', // Enhanced button shadow
																	transition: 'all 0.2s ease',
																	'&:hover': {
																		transform: 'translateY(-2px)',
																		boxShadow: '0 6px 12px rgba(0,0,0,0.3)'
																	}
																}}
																startIcon={<LocalShipping style={{ fontSize: '24px', color: '#fff' }} />}
															>
																{t("Delivery")}
															</Button>
														</motion.div>
													) : (
														<></>
													)}
												</>
											)}
										</div>
									</div>

									{/* Browse Menu Button */}
									<motion.div
										initial="hidden"
										whileInView="visible"

										variants={scrollVariants}
										style={{ display: 'flex', justifyContent: 'center' }}
										whileHover={{ scale: 1.02 }}
									>
										<ButtonStrap
											variant="outlined"
											onClick={() => EnterToSections()}
											style={{
												borderColor: themeSettings.textColor,
												color: themeSettings.textColor,
												padding: '10px 24px',
												borderRadius: '8px',
												fontWeight: 500,
												textTransform: 'none',
												fontSize: '14px',
												width: 'auto',
												borderWidth: '1px'
											}}
										>
											{t("Browse Menu")}
										</ButtonStrap>
									</motion.div>
								</motion.div>


								<motion.div
									initial="hidden"
									whileInView="visible"

									variants={scrollVariants}
									style={{ margin: '24px 0' }}

									animate="visible"
								>
									<Typography
										variant="h6"
										style={{
											color: themeSettings.textColor,
											fontWeight: 600,
											textAlign: 'center',
											fontSize: '30px',
											lineHeight: '1.5',
											letterSpacing: '0.02em',
											textTransform: 'uppercase',
										}}
									>
										{t("How to Order !?")}
									</Typography>

									<motion.div
										initial="hidden"
										whileInView="visible"

										variants={scrollVariants}
										animate={{ opacity: 1, height: 'auto' }}
										transition={{ duration: 0.3 }}
										style={{
											borderRadius: '12px',
											padding: '16px',
											marginBottom: '24px',
										}}
									>
										<Typography
											variant="h6"
											style={{
												marginBottom: '25px',
												fontWeight: 600,
												textAlign: 'center',
												fontSize: '22px',
												lineHeight: '0.5',
												letterSpacing: '0.02em',
												textTransform: 'uppercase',
												color: themeSettings.textColor


											}}
										>
											{t("It's Very Easy !")}
										</Typography>

										<Grid style={{ padding: '16px' }} container spacing={2}>
											{howToOrderSteps.map((step, index) => (
												<Grid item xs={12} sm={6} key={index}>
													<motion.div
														initial="hidden"
														whileInView="visible"

														variants={scrollVariants}
														whileHover={{ scale: 1.02 }}
														style={{
															backgroundColor: themeSettings.cardColor,
															display: 'flex',
															flexDirection: 'column',
															alignItems: 'center',
															padding: '12px',
															textAlign: 'center',
															border: `1px solid ${themeSettings.cardBorderColor}`,
															borderRadius: '8px',
														}}
													>
														{step.icon}
														<Typography
															variant="subtitle1"
															style={{
																color: themeSettings.textColor,
																fontWeight: 500,
																margin: '8px 0'
															}}
														>
															{step.title}
														</Typography>
														<Typography
															variant="body2"
															style={{
																color: themeSettings.textColor,
																opacity: 0.8
															}}
														>
															{step.description}
														</Typography>
													</motion.div>
												</Grid>
											))}
										</Grid>
									</motion.div>


								</motion.div>



								{/* Location Map Section */}
								{treeData?.data?.data?.details?.latitude && treeData?.data?.data?.details?.longitude && (
									<>
										<motion.div
											initial="hidden"
											whileInView="visible"

											variants={scrollVariants}
											style={{
												margin: '24px 0',
												borderRadius: '12px',
												overflow: 'hidden',
												boxShadow: '0 4px 8px rgba(0,0,0,0.1)',
												height: '200px',
												width: '100vw'
											}}

											animate="visible"

										>
											<MapContainer
												center={[venueLocation.lat, venueLocation.lng]}
												zoom={15}
												style={{ height: '100%', width: '100%' }}
												zoomControl={false}
												dragging={false}
												touchZoom={false}
												doubleClickZoom={false}
												scrollWheelZoom={false}
												boxZoom={false}
												keyboard={false}
												tap={false}



											>
												<TileLayer

													url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
													attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
												/>
												<Marker position={[venueLocation.lat, venueLocation.lng]}>
													<Popup>
														{treeData?.data?.data?.details?.venu_name}
													</Popup>
												</Marker>
											</MapContainer>
										</motion.div>

										<motion.div
											initial="hidden"
											whileInView="visible"

											variants={scrollVariants}
											style={{ display: 'flex', justifyContent: 'center' }}
											whileHover={{ scale: 1.02 }}
										>
											<ButtonStrap

												variant="outlined"
												onClick={() => handleSocialPage(
													[venueLocation.lat, venueLocation.lng],
													'map'
												)}
												style={{
													borderColor: themeSettings.textColor,
													color: themeSettings.textColor,
													padding: '5px 24px',
													borderRadius: '8px',
													fontWeight: 500,
													textTransform: 'none',
													fontSize: '14px',
													width: 'auto',
													borderWidth: '1px'
												}}
											>

												{t("Open in Maps")}
												{" "}
												<MapOutlined />
											</ButtonStrap>
										</motion.div>
									</>
								)}
								{treeData?.data?.data?.details?.facebook ||
									treeData?.data?.data?.details?.public_whatsapp ||
									treeData?.data?.data?.details?.instagram ||
									treeData?.data?.data?.details?.twitter ||
									treeData?.data?.data?.details?.snapchat ||
									treeData?.data?.data?.details?.website ||
									treeData?.data?.data?.details?.tiktok ? (
									<motion.div
										initial="hidden"
										whileInView="visible"

										variants={scrollVariants}
										style={{
											marginTop: '20px',
											padding: '10px 0',
											borderTop: `1px solid ${themeSettings.cardBorderColor}`
										}}

										animate="visible"
									>
										<Typography
											variant="h6"
											style={{
												color: themeSettings.textColor,
												marginBottom: '16px',
												fontWeight: 600,
												listStyle: "none"
											}}
										>
											{t("Follow Us")}
										</Typography>

										<div style={{
											display: 'flex',
											justifyContent: 'center',
											flexWrap: 'wrap',
											gap: '16px',
											listStyle: "none"
										}}>
											{treeData?.data?.data?.details?.facebook ? (
												<motion.li className="mx-2" whileHover={{ scale: 1.2 }}>
													<img
														onClick={() =>
															handleSocialPage(treeData?.data?.data?.details?.facebook, 'facebook')
														}
														src={ISDARKTHEME(
															getLocalStorageMenuItem("theme") ||
															treeData?.details?.mobile_settings?.theme,
															setMobileBackColor() ||
															treeData?.details?.mobile_settings?.colorProps?.back
														) ? FacebookDarkTheme : Facebook}
														alt="Facebook icon"
														className="cursor"
													/>
												</motion.li>
											) : <></>}
											{treeData?.data?.data?.details?.public_whatsapp ? (
												<motion.li className="mx-2" whileHover={{ scale: 1.2 }}>
													<img
														style={{ width: "22px", height: "22px" }}
														onClick={() =>
															handleSocialPage(treeData?.data?.data?.details?.public_whatsapp, 'whatsapp')
														}
														src={ISDARKTHEME(
															getLocalStorageMenuItem("theme") ||
															treeData?.details?.mobile_settings?.theme,
															setMobileBackColor() ||
															treeData?.details?.mobile_settings?.colorProps?.back
														) ? WhatsappDarkTheme : Whatsapp}
														alt="Whatsapp icon"
														className="cursor"
													/>
												</motion.li>
											) : <></>}
											{treeData?.data?.data?.details?.instagram ? (
												<motion.li className="mx-2" whileHover={{ scale: 1.2 }}>
													<img
														onClick={() =>
															handleSocialPage(treeData?.data?.data?.details?.instagram, 'instagram')
														}
														src={ISDARKTHEME(
															getLocalStorageMenuItem("theme") ||
															treeData?.details?.mobile_settings?.theme,
															setMobileBackColor() ||
															treeData?.details?.mobile_settings?.colorProps?.back
														) ? InstagramDarkTheme : Instagram}
														alt="Instagram icon"
														className="cursor"
													/>
												</motion.li>
											) : <></>}
											{treeData?.data?.data?.details?.twitter ? (
												<motion.li className="mx-2" whileHover={{ scale: 1.2 }}>
													<img
														onClick={() =>
															handleSocialPage(treeData?.data?.data?.details?.twitter, 'twitter')
														}
														src={ISDARKTHEME(
															getLocalStorageMenuItem("theme") ||
															treeData?.details?.mobile_settings?.theme,
															setMobileBackColor() ||
															treeData?.details?.mobile_settings?.colorProps?.back
														) ? TwitterDarkTheme : Twitter}
														alt="X icon"
														className="cursor"
													/>
												</motion.li>
											) : <></>}
											{treeData?.data?.data?.details?.snapchat && (
												<motion.li className="mx-2" whileHover={{ scale: 1.2 }}>
													<img
														onClick={() =>
															handleSocialPage(treeData?.data?.data?.details?.snapchat, 'snapchat')
														}
														src={ISDARKTHEME(
															getLocalStorageMenuItem("theme") ||
															treeData?.details?.mobile_settings?.theme,
															setMobileBackColor() ||
															treeData?.details?.mobile_settings?.colorProps?.back
														) ? SnapchatDarkTheme : Snapchat}
														alt="Snapchat icon"
														className="cursor"
													/>
												</motion.li>
											)}
											{treeData?.data?.data?.details?.website ? (
												<motion.li className="mx-2" whileHover={{ scale: 1.2 }}>
													<img
														onClick={() =>
															handleSocialPage(treeData?.data?.data?.details?.website, 'website')
														}
														src={ISDARKTHEME(
															getLocalStorageMenuItem("theme") ||
															treeData?.details?.mobile_settings?.theme,
															setMobileBackColor() ||
															treeData?.details?.mobile_settings?.colorProps?.back
														) ? GlobalDarkTheme : Global}
														alt="global icon"
														className="cursor"
													/>
												</motion.li>
											) : <></>}
											{treeData?.data?.data?.details?.tiktok ? (
												<motion.li className="mx-2" whileHover={{ scale: 1.2 }}>
													<img
														onClick={() =>
															handleSocialPage(treeData?.data?.data?.details?.tiktok, 'tiktok')
														}
														src={ISDARKTHEME(
															getLocalStorageMenuItem("theme") ||
															treeData?.details?.mobile_settings?.theme,
															setMobileBackColor() ||
															treeData?.details?.mobile_settings?.colorProps?.back
														) ? Tiktok_Dark : Tiktok_Light}
														alt="global icon"
														className="cursor"
													/>
												</motion.li>
											) : <></>}
										</div>
									</motion.div>
								) : <></>}



								{/* Opening Hours */}
								<motion.div
									initial="hidden"
									whileInView="visible"

									variants={scrollVariants}

									animate="visible"
								>
									<p
										className="text-center head-font alignByLang"
										style={{
											cursor: 'pointer',
											color: setMobileTextColor(),
											marginTop: "20px",
											marginBottom: "10%",
											display: 'flex',
											alignItems: 'center',
											justifyContent: 'center',
											gap: '8px'
										}}
										onClick={toggleDrawer(true)}
									>
										<Schedule style={{ fontSize: '20px' }} />
										{t("Opening hours")}
										{getLocalStorageMenuItem("lang") === "ar" || getLocalStorageMenuItem("lang") === "fr" ?
											<ArrowLeftOutlined /> : <ArrowRightOutlined />}
									</p>
								</motion.div>

								<SwipeableDrawer
									anchor="bottom"
									open={drawerOpen}
									onClose={toggleDrawer(false)}
									onOpen={toggleDrawer(true)}
								>
									<div
										style={{
											width: '100%',
											backgroundColor: setMobileBackColor(),
											position: 'relative',
											padding: '16px',
										}}
										role="presentation"
									>
										<div className="alignByLang" style={{ paddingLeft: "20px", paddingRight: "20px", paddingTop: "25px" }}>
											<Badge
												className={`${getLocalStorageMenuItem("theme") === "dark" ? "waiting-badge-style-dark" : ""} p-2 font-size-18 sub-font m-1`}
											>
												{getLocalStorageMenuItem("tree_data")?.details?.menu_name || treeData?.data?.data?.details?.menu_name}
											</Badge>
										</div>

										<CloseOutlined
											className="alignByLang"
											onClick={toggleDrawer(false)}
											style={getLocalStorageMenuItem("lang") === "ar" || getLocalStorageMenuItem("lang") === "fr" ? {
												position: 'absolute',
												top: 10,
												left: 10,
												cursor: 'pointer',
												color: setMobileTextColor()
											} :
												{
													position: 'absolute',
													top: 10,
													right: 10,
													cursor: 'pointer',
													color: setMobileTextColor()
												}}
										/>
										<MenuAvailabilityComponent availability={treeData?.data?.data?.details?.availability} />
									</div>
								</SwipeableDrawer>
							</motion.div>

							<LoginComponent
								open={loginDialogOpen}
								handleCloseDialog={handleCloseLoginDialog}
								tableQr={tableQr}
								tableName={tableName}
								onVerificationSuccess={handleVerificationSuccess}
								is_from={getLocalStorageMenuItem("pendingDelivery") ? 3 : 1}
							/>

							<Toast
								open={toastSettings.open}
								message={toastSettings.message}
								resetToast={handleCloseToast}
								success={toastSettings.success}
							/>
						</Container>
					</div>
				</div>

				<motion.footer
					initial="hidden"
					whileInView="visible"
					variants={scrollVariants}
					style={{
						backgroundColor: themeSettings.cardColor,
						padding: '12px 8px',
						borderTop: `1px solid ${themeSettings.cardBorderColor}`,
						marginTop: '5px'
					}}
				>
					<Container>
						{/* First Section - Logo and Venue Name */}
						<div style={{
							display: 'flex',
							flexDirection: 'column',
							alignItems: 'center',
							marginBottom: '24px',
							padding: 0
						}}>
							<img
								src={treeData?.data?.data?.details?.logo || no_image}
								alt="Venue Logo"
								style={{
									width: '80px',
									height: '80px',
									borderRadius: '50%',
									objectFit: 'cover',
									marginBottom: '16px',
									border: `2px solid ${themeSettings.cardBorderColor}`
								}}
								onError={onImageError}
							/>
							<Typography
								variant="h6"
								style={{
									color: themeSettings.textColor,
									fontWeight: 600,
									textAlign: 'center'
								}}
							>
								{treeData?.data?.data?.details?.venu_name}
							</Typography>
						</div>

						{/* Second Section - Links */}
						<div style={{
							display: 'flex',
							justifyContent: 'center',
							flexWrap: 'wrap',
							gap: '0px'
						}}>
							{/* Home Link */}
							<Button
								variant="text"
								onClick={EnterToSections}
								style={{
									color: themeSettings.textColor,
									textTransform: 'none'
								}}
							>
								{t("Home")}
							</Button>

							{/* Profile Link (if logged in) */}
							{getLocalStorageMenuItem("mobileLoginToken") && (
								<Button
									variant="text"
									onClick={() => handleClickNavigation("profile")}
									style={{
										color: themeSettings.textColor,
										textTransform: 'none'
									}}
								>
									{t("My Profile")}
								</Button>
							)}

							{/* Orders Link */}
							{allTreeData?.details?.order_ability && getLocalStorageMenuItem("mobileLoginToken") && (
								<Button
									variant="text"
									onClick={() => handleClickNavigation("orders")}
									style={{
										color: themeSettings.textColor,
										textTransform: 'none'
									}}
								>
									{t("My orders")}
								</Button>
							)}

							{/* Wallet Link */}
							{getLocalStorageMenuItem("mobileLoginToken") && (
								<Button
									variant="text"
									onClick={() => handleClickNavigation("transactions")}
									style={{
										color: themeSettings.textColor,
										textTransform: 'none'
									}}
								>
									{t("Wallet")}
								</Button>
							)}

							{/* Favorites Link */}
							<Button
								variant="text"
								onClick={() => handleClickNavigation("favorites")}
								style={{
									color: themeSettings.textColor,
									textTransform: 'none'
								}}
							>
								{t("Favorites")}
							</Button>

							{/* Feedback Link */}
							<Button
								variant="text"
								onClick={() => handleClickNavigation("feedback")}
								style={{
									color: themeSettings.textColor,
									textTransform: 'none'
								}}
							>
								{t("Your opinion Matters!")}
							</Button>

							{/* Privacy Policy Link */}
							<Button
								variant="text"
								onClick={() => handleClickNavigation("privacy")}
								style={{
									color: themeSettings.textColor,
									textTransform: 'none'
								}}
							>
								{t("Privacy Policy")}
							</Button>

							{/* Terms and Conditions Link */}
							<Button
								variant="text"
								onClick={() => handleClickNavigation("terms")}
								style={{
									color: themeSettings.textColor,
									textTransform: 'none'
								}}
							>
								{t("Terms and Conditions")}
							</Button>

							{/* Logout Link (if logged in) */}
							{getLocalStorageMenuItem("mobileLoginToken") && (
								<Button
									variant="text"
									onClick={() => handleClickNavigation("logout")}
									style={{
										color: themeSettings.textColor,
										textTransform: 'none'
									}}
								>
									{t("Logout")}
								</Button>
							)}
						</div>

						{/* Copyright Text */}
						<Typography
							variant="body2"
							style={{
								color: themeSettings.textColor,
								opacity: 0.7,
								textAlign: 'center',
								marginTop: '24px'
							}}
						>
							© {new Date().getFullYear()} {treeData?.data?.data?.details?.venu_name}. {t("All rights reserved")}
						</Typography>
					</Container>
				</motion.footer>

			</div>

			{/* Delivery Workflow Dialogs */}
			<DeliveryDialog
				open={deliveryDialogOpen}
				savedPlaces={savedPlaces}
				isLoadingSavedPlaces={loadingSavedPlaces}
				openLocationFormDailog={() => setOpenLocationFormDialog(true)}
				onClose={() => setDeliveryDialogOpen(false)}
				onSelect={handleOptionSelect}
				onSelectPlace={handleSelectPlace}
				openDeleteLocationDialog={handleOpenDeleteLocationDialog}
			/>

			<CurrentLocationDialog
				open={mode === "current"}
				onClose={() => setMode(null)}
				setLatLangVal={setLatLangVal}
				updateLocationFormData={updateLocationFormData}
				setMobileBackColor={setMobileBackColor}
				setMobileTextColor={setMobileTextColor}
				setMobileCardBorderColor={setMobileCardBorderColor}
			/>

			<NewLocationDialog
				open={mode === "new"}
				onClose={() => setMode(null)}
				openLocationFormDailog={() => setOpenLocationFormDialog(true)}
				closeLocationFormDailog={() => handleCloseFormDialog()}
				setLatLangVal={setLatLangVal}
				closeMapModal={() => setMode(null)}
				updateLocationFormData={(pickupMapAddress) => updateLocationFormData(pickupMapAddress)}
				setMobileBackColor={setMobileBackColor}
				setMobileTextColor={setMobileTextColor}
				setMobileCardBorderColor={setMobileCardBorderColor}
			/>

			<LocationFormDialog
				open={openLocationFormDialog}
				onClose={handleCloseFormDialog}
				isEditDelivery={isEditDelivery}
				isProcessLoading={isProcessLoading}
				locationFormData={locationFormData}
				handleLocationFormInputChange={(e) => {
					setLocationFormData(prev => ({ ...prev, [e.target.name]: e.target.value }));
				}}
				handleSaveLocation={handleSaveLocation}
				handleUpdateLocation={handleUpdateLocation}
				setMobileBackColor={setMobileBackColor}
				setMobileTextColor={setMobileTextColor}
				setMobileCardBorderColor={setMobileCardBorderColor}
				setMobileCardColor={setMobileCardColor}
				setMobileButttonBackColor={setMobileButttonBackColor}
			/>

			<DeleteLocationDialog
				onDeleteDeleteLocationDialog={handleDeleteLocation}
				deleteLocationDialogOpen={deleteLocationDialogOpen}
				onCloseDeleteLocationDialog={() => setDeleteLocationDialogOpen(false)}
			/>

			<Backdrop open={isProcessLoading} sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}>
				<CircularProgress color="inherit" />
			</Backdrop>


			<Dialog
				open={showInfoDailog}
				onClose={() => setShowInfoDailog(false)}
				maxWidth="sm"
				PaperProps={{
					style: {
						borderRadius: 15,
						padding: "20px",
						backgroundColor: dialogStyles.backgroundColor,
						border: `1px solid ${setMobileCardBorderColor()}'}`,
					},
				}}
			>
				<DialogTitle sx={{ textAlign: "center", paddingBottom: 0 }}>
					<Typography variant="h6" fontWeight="bold" color={setMobileTextColor()}>
						{t("Hi")}
					</Typography>
				</DialogTitle>
				<DialogContent>
					<Box sx={{ display: "flex", justifyContent: "center", padding: "10px" }}>
						<Typography variant="body1" textAlign="center" color={dialogStyles.color}>
							{t("Your order sent and it will be with you as sson as possible, Thank you.")}
						</Typography>
					</Box>
				</DialogContent>
				<DialogActions sx={{ justifyContent: "center" }}>
					<Button
						onClick={() => setShowInfoDailog(false)}
						sx={{
							backgroundColor: setMobileCardBorderColor(),
							color: '#fff',
							padding: "8px 16px",
							borderRadius: "30px",
							"&:hover": {
								backgroundColor: setMobileCardBorderColor(),
							},
						}}
					>
						{t("ok")}
					</Button>
				</DialogActions>
			</Dialog>
		</div>
	);
};

export default WellcomeScreen;